import Ue, { produce as Wt } from "immer";
import ht, { useReducer as W, useCallback as R, useEffect as b, createContext as mt, useRef as _e, useMemo as Oe, useState as oe } from "react";
import { Status as u } from "@prometheus/types";
import { parseFiltersToStringParams as Ut, keyBy as zt, formatFilterListNoFiql as qt, getReducerWithProduce as Ie, convertListToHashMap as Xt, getNumberUUID as bt, collectIds as Je, getNumberUUIDWidthLimit as at, getSortDirection as gt, api as Z, convertVersionListDTOToVersionList as Kt, parseActions as je, isEqual as Te, checkFormatDateSave as nt, generateAlias as Zt } from "@prometheus/utils";
import { Modal as Jt, ModalTitle as eo, useNotifications as Pt } from "@prometheus/components";
import { MetaAttributeTypes as Ve, AnalysisTypes as g, DateFormat as Et, TypesOfContainer as ct, EntityTypes as to, FileExtension as lt, mapStandardConceptTypes as oo } from "@prometheus/enums";
var k = /* @__PURE__ */ ((e) => (e.FETCH_REQUEST = "FETCH_REQUEST", e.FETCH_REQUEST_DONE = "FETCH_REQUEST_DONE", e.FETCH_REQUEST_FAILED = "FETCH_REQUEST_FAILED", e.REMOVE_REQUEST = "REMOVE_REQUEST", e.REMOVE_REQUEST_DONE = "REMOVE_REQUEST_DONE", e.REMOVE_REQUEST_FAILED = "REMOVE_REQUEST_FAILED", e.SET_COUNT = "SET_COUNT", e.SET_SIZE = "SET_SIZE", e.SET_QUERY = "SET_QUERY", e.SET_SORT = "SET_SORT", e.SET_NUMBER = "SET_NUMBER", e.SET_LIST_SORTING = "SET_LIST_SORTING", e.UPDATE_FILTERS = "UPDATE_FILTERS", e.RESET_STATE = "RESET_STATE", e))(k || {});
const Me = {
  data: { tableData: [], filtersData: [] },
  pageCount: 1,
  pageSize: 15,
  isLoading: !1,
  isReloadLoading: !1,
  pageNumber: 0,
  sort: null,
  totalElements: 0,
  numberOfElements: 0,
  actions: null,
  allowedSorting: [],
  filters: {},
  status: u.INITIAL,
  error: null
}, so = (e, o) => Ue(e, (t) => {
  var s;
  switch (o.type) {
    case k.FETCH_REQUEST:
      t.status = t.status === u.INITIAL ? u.IN_PROGRESS : u.IN_PROGRESS_RELOAD;
      break;
    case k.FETCH_REQUEST_DONE:
      t.data.tableData = o.payload.content || o.payload, t.data.filtersData = o.payload.filters, t.actions = o.payload.actions, t.pageCount = o.payload.totalPages || 1, t.pageNumber = ((s = o.payload.pageable) == null ? void 0 : s.pageNumber) || 0, t.numberOfElements = o.payload.numberOfElements, t.totalElements = o.payload.totalElements, t.sort = o.payload.sort, t.status = u.SUCCESS;
      break;
    case k.UPDATE_FILTERS:
      t.filters = {
        ...t.filters,
        ...o.payload
      };
      break;
    case k.FETCH_REQUEST_FAILED:
      t.data.tableData = [], t.actions = [], t.error = o.payload, t.status = u.ERROR;
      break;
    case k.SET_COUNT:
      t.pageCount = o.payload;
      break;
    case k.SET_SIZE:
      t.pageSize = o.payload;
      break;
    case k.SET_NUMBER:
      t.pageNumber = o.payload;
      break;
    case k.REMOVE_REQUEST:
      break;
    case k.REMOVE_REQUEST_DONE:
      break;
    case k.REMOVE_REQUEST_FAILED:
      break;
    case k.SET_LIST_SORTING:
      t.allowedSorting = o.payload;
      break;
    case k.RESET_STATE:
      t.data.tableData = [], t.data.filtersData = [], t.filters = {}, t.actions = [], t.pageCount = 1, t.pageNumber = 0, t.numberOfElements = 0, t.totalElements = 0, t.sort = {}, t.status = u.INITIAL;
      break;
  }
}), xs = (e, o, t, s) => {
  const [r, n] = W(so, {
    ...Me,
    filters: (s == null ? void 0 : s.filters) || Me.filters,
    pageSize: (s == null ? void 0 : s.pageSize) || Me.pageSize,
    sort: (s == null ? void 0 : s.sort) || Me.sort
  }), a = R(
    async (C, O, D, I = !1) => {
      var m;
      I || n({
        type: k.FETCH_REQUEST,
        payload: t && o
      });
      try {
        const f = Ut(r.filters), Q = await e.get(
          C,
          O,
          D,
          f
        );
        if (I) return zt(Q.content || Q, "id");
        const $ = await ((m = e.getFilters) == null ? void 0 : m.call(e, f).then(qt)) || [];
        n({
          type: k.FETCH_REQUEST_DONE,
          payload: {
            ...Q,
            reload: t && o,
            filters: $,
            sort: D
          }
        });
      } catch (f) {
        console.error("ERROR", f), n({
          type: k.FETCH_REQUEST_FAILED,
          payload: f
        });
      }
    },
    [e.get, r.filters, o]
  ), l = R(
    async (C) => {
      n({
        type: k.REMOVE_REQUEST,
        payload: C
      });
      try {
        return await e.remove(C), await a(r.pageNumber, r.pageSize, r.sort), n({
          type: k.REMOVE_REQUEST_DONE,
          payload: C
        }), !0;
      } catch (O) {
        return n({
          type: k.REMOVE_REQUEST_FAILED,
          payload: {
            err: O
          }
        }), !1;
      }
    },
    [e.remove, r.pageNumber, r.pageSize, r.sort]
  ), A = R(
    (C) => {
      n({
        type: k.UPDATE_FILTERS,
        payload: C
      });
    },
    [r.filters]
  ), _ = R((C) => {
    n({
      type: k.SET_COUNT,
      payload: C
    });
  }, []), i = R((C) => {
    n({
      type: k.SET_NUMBER,
      payload: C
    });
  }, []), T = (C) => {
    n({
      type: k.SET_SIZE,
      payload: C
    });
  }, p = R((C) => {
    n({
      type: k.SET_QUERY,
      payload: C
    });
  }, []), c = R(async () => {
    if (e != null && e.getSorting)
      try {
        const C = await e.getSorting();
        n({
          type: k.SET_LIST_SORTING,
          payload: C
        });
      } catch {
        console.error("GET LIST SORTING: sth went wrong");
      }
  }, []), y = () => {
    n({ type: k.RESET_STATE });
  };
  return b(() => {
    c();
  }, [c]), {
    ...r,
    getEntity: a,
    removeEntity: l,
    setPageCount: _,
    setPageNumber: i,
    setPageSize: T,
    setQuery: p,
    updateFilters: A,
    resetState: y
  };
};
var qe = { exports: {} }, we = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var it;
function ro() {
  if (it) return we;
  it = 1;
  var e = Symbol.for("react.transitional.element"), o = Symbol.for("react.fragment");
  function t(s, r, n) {
    var a = null;
    if (n !== void 0 && (a = "" + n), r.key !== void 0 && (a = "" + r.key), "key" in r) {
      n = {};
      for (var l in r)
        l !== "key" && (n[l] = r[l]);
    } else n = r;
    return r = n.ref, {
      $$typeof: e,
      type: s,
      key: a,
      ref: r !== void 0 ? r : null,
      props: n
    };
  }
  return we.Fragment = o, we.jsx = t, we.jsxs = t, we;
}
var ke = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tt;
function ao() {
  return Tt || (Tt = 1, process.env.NODE_ENV !== "production" && function() {
    function e(E) {
      if (E == null) return null;
      if (typeof E == "function")
        return E.$$typeof === fe ? null : E.displayName || E.name || null;
      if (typeof E == "string") return E;
      switch (E) {
        case C:
          return "Fragment";
        case D:
          return "Profiler";
        case O:
          return "StrictMode";
        case Q:
          return "Suspense";
        case $:
          return "SuspenseList";
        case v:
          return "Activity";
      }
      if (typeof E == "object")
        switch (typeof E.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), E.$$typeof) {
          case y:
            return "Portal";
          case m:
            return (E.displayName || "Context") + ".Provider";
          case I:
            return (E._context.displayName || "Context") + ".Consumer";
          case f:
            var L = E.render;
            return E = E.displayName, E || (E = L.displayName || L.name || "", E = E !== "" ? "ForwardRef(" + E + ")" : "ForwardRef"), E;
          case x:
            return L = E.displayName || null, L !== null ? L : e(E.type) || "Memo";
          case B:
            L = E._payload, E = E._init;
            try {
              return e(E(L));
            } catch {
            }
        }
      return null;
    }
    function o(E) {
      return "" + E;
    }
    function t(E) {
      try {
        o(E);
        var L = !1;
      } catch {
        L = !0;
      }
      if (L) {
        L = console;
        var U = L.error, P = typeof Symbol == "function" && Symbol.toStringTag && E[Symbol.toStringTag] || E.constructor.name || "Object";
        return U.call(
          L,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          P
        ), o(E);
      }
    }
    function s(E) {
      if (E === C) return "<>";
      if (typeof E == "object" && E !== null && E.$$typeof === B)
        return "<...>";
      try {
        var L = e(E);
        return L ? "<" + L + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function r() {
      var E = Re.A;
      return E === null ? null : E.getOwner();
    }
    function n() {
      return Error("react-stack-top-frame");
    }
    function a(E) {
      if (V.call(E, "key")) {
        var L = Object.getOwnPropertyDescriptor(E, "key").get;
        if (L && L.isReactWarning) return !1;
      }
      return E.key !== void 0;
    }
    function l(E, L) {
      function U() {
        Ce || (Ce = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          L
        ));
      }
      U.isReactWarning = !0, Object.defineProperty(E, "key", {
        get: U,
        configurable: !0
      });
    }
    function A() {
      var E = e(this.type);
      return h[E] || (h[E] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), E = this.props.ref, E !== void 0 ? E : null;
    }
    function _(E, L, U, P, Y, F, ce, le) {
      return U = F.ref, E = {
        $$typeof: c,
        type: E,
        key: L,
        props: F,
        _owner: Y
      }, (U !== void 0 ? U : null) !== null ? Object.defineProperty(E, "ref", {
        enumerable: !1,
        get: A
      }) : Object.defineProperty(E, "ref", { enumerable: !1, value: null }), E._store = {}, Object.defineProperty(E._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(E, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(E, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ce
      }), Object.defineProperty(E, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: le
      }), Object.freeze && (Object.freeze(E.props), Object.freeze(E)), E;
    }
    function i(E, L, U, P, Y, F, ce, le) {
      var G = L.children;
      if (G !== void 0)
        if (P)
          if (z(G)) {
            for (P = 0; P < G.length; P++)
              T(G[P]);
            Object.freeze && Object.freeze(G);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else T(G);
      if (V.call(L, "key")) {
        G = e(E);
        var se = Object.keys(L).filter(function(q) {
          return q !== "key";
        });
        P = 0 < se.length ? "{key: someKey, " + se.join(": ..., ") + ": ...}" : "{key: someKey}", N[G + P] || (se = 0 < se.length ? "{" + se.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          P,
          G,
          se,
          G
        ), N[G + P] = !0);
      }
      if (G = null, U !== void 0 && (t(U), G = "" + U), a(L) && (t(L.key), G = "" + L.key), "key" in L) {
        U = {};
        for (var ue in L)
          ue !== "key" && (U[ue] = L[ue]);
      } else U = L;
      return G && l(
        U,
        typeof E == "function" ? E.displayName || E.name || "Unknown" : E
      ), _(
        E,
        G,
        F,
        Y,
        r(),
        U,
        ce,
        le
      );
    }
    function T(E) {
      typeof E == "object" && E !== null && E.$$typeof === c && E._store && (E._store.validated = 1);
    }
    var p = ht, c = Symbol.for("react.transitional.element"), y = Symbol.for("react.portal"), C = Symbol.for("react.fragment"), O = Symbol.for("react.strict_mode"), D = Symbol.for("react.profiler"), I = Symbol.for("react.consumer"), m = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), Q = Symbol.for("react.suspense"), $ = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), B = Symbol.for("react.lazy"), v = Symbol.for("react.activity"), fe = Symbol.for("react.client.reference"), Re = p.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, V = Object.prototype.hasOwnProperty, z = Array.isArray, M = console.createTask ? console.createTask : function() {
      return null;
    };
    p = {
      react_stack_bottom_frame: function(E) {
        return E();
      }
    };
    var Ce, h = {}, S = p.react_stack_bottom_frame.bind(
      p,
      n
    )(), d = M(s(n)), N = {};
    ke.Fragment = C, ke.jsx = function(E, L, U, P, Y) {
      var F = 1e4 > Re.recentlyCreatedOwnerStacks++;
      return i(
        E,
        L,
        U,
        !1,
        P,
        Y,
        F ? Error("react-stack-top-frame") : S,
        F ? M(s(E)) : d
      );
    }, ke.jsxs = function(E, L, U, P, Y) {
      var F = 1e4 > Re.recentlyCreatedOwnerStacks++;
      return i(
        E,
        L,
        U,
        !0,
        P,
        Y,
        F ? Error("react-stack-top-frame") : S,
        F ? M(s(E)) : d
      );
    };
  }()), ke;
}
process.env.NODE_ENV === "production" ? qe.exports = ro() : qe.exports = ao();
var ne = qe.exports, Ne = /* @__PURE__ */ ((e) => (e.SET_COMPONENT = "SET_COMPONENT", e.SHOW_DIALOG = "SHOW_DIALOG", e.HIDE_DIALOG = "HIDE_DIALOG", e.DESTROY_DIALOG = "DESTROY_DIALOG", e))(Ne || {});
const no = (e, o) => Ue(e, (t) => {
  switch (o.type) {
    case Ne.SET_COMPONENT: {
      t.component = o.payload;
      break;
    }
    case Ne.SHOW_DIALOG: {
      t.components.push({
        component: o.payload.component,
        props: { ...o.payload.props, open: !0 }
      }), t.component = o.payload.component, t.props = { ...o.payload.props, open: !0 };
      break;
    }
    case Ne.HIDE_DIALOG: {
      t.components.shift(), t.props = { ...t.props, open: !1 };
      break;
    }
    case Ne.DESTROY_DIALOG: {
      t.component = null, t.props = {};
      break;
    }
  }
}), Eo = {
  components: [],
  component: null,
  props: {}
}, co = () => {
  const [e, o] = W(no, Eo), t = (n, a) => {
    o({
      type: Ne.SHOW_DIALOG,
      payload: { component: n, props: a }
    });
  }, s = () => {
    o({
      type: Ne.HIDE_DIALOG
    });
  }, r = R(() => {
    o({
      type: Ne.DESTROY_DIALOG
    });
  }, []);
  return {
    ...e,
    dialogCount: e.components.length,
    hideDialog: s,
    showDialog: t,
    destroyDialog: r
  };
}, ft = "__prometheusOverlayHistory", _t = {
  modal: 0,
  dialog: 0
}, Xe = (e) => typeof e == "object" && e !== null, ut = (e) => typeof e != "number" || !Number.isFinite(e) || e <= 0 ? 0 : Math.floor(e), vt = (e = window.history.state) => {
  if (!Xe(e))
    return _t;
  const o = e[ft];
  return Xe(o) ? {
    modal: ut(o.modal),
    dialog: ut(o.dialog)
  } : _t;
}, Pe = (e, o = window.history.state) => vt(o)[e], xe = [], Ke = /* @__PURE__ */ new Set();
let $e = !1;
const lo = (e, o) => {
  const t = Xe(window.history.state) ? window.history.state : {}, s = {
    ...vt(window.history.state),
    [e]: o
  };
  window.history.pushState(
    {
      ...t,
      [ft]: s
    },
    "",
    window.location.href
  );
}, et = () => {
  for (; !$e && xe.length; ) {
    const e = xe.shift();
    "steps" in e ? ($e = !0, window.history.go(-e.steps)) : lo(e.key, e.count);
  }
};
typeof window < "u" && window.addEventListener("popstate", (e) => {
  $e ? ($e = !1, et()) : Ke.forEach((o) => o(e));
});
const wt = (e, o) => {
  xe.push({ key: e, count: o }), et();
}, Be = (e = 1) => {
  xe.push({ steps: e }), et();
}, kt = (e) => (Ke.add(e), () => {
  Ke.delete(e);
}), io = mt(null), $s = ({
  // initialComponent,
  children: e
}) => {
  const {
    // component,
    components: o,
    dialogCount: t,
    // props,
    showDialog: s,
    hideDialog: r,
    destroyDialog: n
  } = co(), a = _e(t), l = _e(t);
  b(() => {
    a.current = t;
  }, [t]), b(() => kt((c) => {
    const y = a.current, C = Pe("dialog", c.state);
    if (C < y)
      for (let O = 0; O < y - C; O++)
        r();
  }), [r]), b(() => {
    const p = l.current;
    if (t > p)
      for (let c = p + 1; c <= t; c++)
        wt("dialog", c);
    l.current = t;
  }, [t]);
  const A = R(() => {
    const p = a.current;
    if (!p)
      return;
    a.current = p - 1, l.current = p - 1, r(), Pe("dialog") >= p && Be();
  }, [r]), _ = R(() => {
    const p = a.current;
    if (!p) {
      n();
      return;
    }
    a.current = 0, l.current = 0, n(), Pe("dialog") >= p && Be(p);
  }, [n]), i = Oe(
    () => ({
      showDialog: s,
      hideDialog: A,
      destroyDialog: _
    }),
    [_, A, s]
  ), T = () => o.map((p, c) => {
    const y = p.component;
    return y ? /* @__PURE__ */ ne.jsx(y, { ...p.props }, c + "-dialog") : /* @__PURE__ */ ne.jsx(ne.Fragment, {});
  });
  return /* @__PURE__ */ ne.jsxs(io.Provider, { value: i, children: [
    e,
    T()
  ] });
}, Ft = {
  form: {},
  data: null,
  getFilters: void 0,
  formatFilters: void 0,
  status: u.INITIAL,
  reloadStatus: u.INITIAL
};
var ee = /* @__PURE__ */ ((e) => (e.SET_FILTER_PANEL = "SET_FILTER_PANEL", e.SET_FILTER_PANEL_DATA = "SET_FILTER_PANEL_DATA", e.RESET_FILTER_PANEL = "RESET_FILTER_PANEL", e.SET_FILTER_PANEL_STATUS = "SET_FILTER_PANEL_STATUS", e.UPDATE_FILTER_PANEL = "UPDATE_FILTER_PANEL", e.UPDATE_FILTER_PANEL_ALL = "UPDATE_FILTER_PANEL_ALL", e.GET_FILTER_PANEL_DATA = "GET_FILTER_PANEL_DATA", e))(ee || {});
const To = (e, o) => Ie(e, (t) => {
  switch (o.type) {
    case ee.SET_FILTER_PANEL: {
      t.getFilters = o.payload.getFilters, t.formatFilters = o.payload.formatFilters, t.filterReqBody = o.payload.filterReqBody, o.payload.filterReqBody && Object.keys(o.payload.filterReqBody).forEach((s) => {
        t.form[s] = o.payload.filterReqBody[s];
      });
      break;
    }
    case ee.GET_FILTER_PANEL_DATA: {
      t.status === u.INITIAL ? t.status = u.IN_PROGRESS : t.reloadStatus = u.IN_PROGRESS;
      break;
    }
    case ee.SET_FILTER_PANEL_DATA: {
      t.data = o.payload, t.reloadStatus = u.SUCCESS, t.status = u.SUCCESS;
      break;
    }
    case ee.SET_FILTER_PANEL_STATUS: {
      t.status = o.payload;
      break;
    }
    case ee.UPDATE_FILTER_PANEL: {
      const { key: s, value: r } = o.payload;
      t.form[s] = r, t.status = u.SUCCESS;
      break;
    }
    case ee.UPDATE_FILTER_PANEL_ALL: {
      t.form = o.payload;
      break;
    }
    case ee.RESET_FILTER_PANEL:
      return { ...t, ...Ft };
  }
}), Bs = (e) => {
  const [o, t] = W(
    To,
    Ft
  ), s = R((_) => {
    t({
      type: ee.SET_FILTER_PANEL_STATUS,
      payload: _
    });
  }, []), r = R(() => {
    t({ type: ee.RESET_FILTER_PANEL });
  }, []), n = R(
    async (_, i, T = {}) => {
      if (_)
        try {
          t({
            type: ee.SET_FILTER_PANEL,
            payload: {
              getFilters: _,
              formatFilters: i,
              filterReqBody: T
            }
          });
        } catch {
          s(u.ERROR);
        }
    },
    []
  ), a = R(
    async (_) => {
      t({ type: ee.GET_FILTER_PANEL_DATA });
      try {
        const i = Ut(_);
        if (e) {
          const T = await (e == null ? void 0 : e.get(i, o.filterReqBody)), p = e != null && e.format ? e.format(T) : T;
          t({
            type: ee.SET_FILTER_PANEL_DATA,
            payload: p
          });
        } else {
          const T = await o.getFilters(i, o.filterReqBody), p = o.formatFilters ? o.formatFilters(T) : T;
          t({
            type: ee.SET_FILTER_PANEL_DATA,
            payload: p
          });
        }
      } catch {
        s(u.ERROR);
      }
    },
    [o.getFilters]
  ), l = R((_, i) => {
    _ && t({
      type: ee.UPDATE_FILTER_PANEL,
      payload: { key: _, value: i }
    });
  }, []), A = R((_) => {
    t({
      type: ee.UPDATE_FILTER_PANEL_ALL,
      payload: _
    });
  }, []);
  return b(() => {
    const { getFilters: _ } = o;
    (_ || e != null && e.get) && a(o.form);
  }, [a, o.form]), {
    ...o,
    setFiltersStatus: s,
    setFilters: n,
    updateFilters: l,
    resetFilters: r,
    updateAllFilters: A
  };
};
var w = /* @__PURE__ */ ((e) => (e.GET_ENTITY_LIST_PENDING = "GET_ENTITY_LIST_PENDING", e.GET_ENTITY_LIST_SUCCESS = "GET_ENTITY_LIST_SUCCESS", e.GET_ENTITY_LIST_FAILURE = "GET_ENTITY_LIST_FAILURE", e.GET_ENTITY_PENDING = "GET_ENTITY_PENDING", e.GET_ENTITY_SUCCESS = "GET_ENTITY_SUCCESS", e.GET_ENTITY_FAILURE = "GET_ENTITY_FAILURE", e.CREATE_ENTITY_PENDING = "CREATE_ENTITY_PENDING", e.CREATE_ENTITY_SUCCESS = "CREATE_ENTITY_SUCCESS", e.CREATE_ENTITY_FAILURE = "CREATE_ENTITY_FAILURE", e.UPDATE_ENTITY_PENDING = "UPDATE_ENTITY_PENDING", e.UPDATE_ENTITY_SUCCESS = "UPDATE_ENTITY_SUCCESS", e.UPDATE_ENTITY_FAILURE = "UPDATE_ENTITY_FAILURE", e.DELETE_ENTITY_PENDING = "DELETE_ENTITY_PENDING", e.DELETE_ENTITY_SUCCESS = "DELETE_ENTITY_SUCCESS", e.DELETE_ENTITY_FAILURE = "DELETE_ENTITY_FAILURE", e.GET_ALLOWED_SORTING_SUCCESS = "GET_ALLOWED_SORTING_SUCCESS", e))(w || {});
function _o(e, o) {
  return Wt(e, (t) => {
    switch (o.type) {
      case w.GET_ENTITY_LIST_PENDING: {
        t.isError = !1, t.isLoading = !0, t.processingIds = [], t.status = t.status === u.INITIAL ? u.IN_PROGRESS : u.IN_PROGRESS_RELOAD;
        break;
      }
      case w.GET_ENTITY_LIST_SUCCESS: {
        const {
          data: s,
          primaryKey: r,
          actions: n,
          totalPages: a,
          totalElements: l,
          numberOfElements: A,
          number: _,
          size: i
        } = o.payload;
        t.ids = s.map((T) => T[r]), t.byId = Xt(s, String(r)), t.rawData = s, t.actions = n, t.isLoading = !1, t.isLoaded = !0, t.pageCount = a || 1, t.totalElements = l, t.numberOfElements = A, t.pageNumber = _ || 0, t.pageSize = i || 10, t.status = u.SUCCESS;
        break;
      }
      case w.GET_ENTITY_LIST_FAILURE: {
        t.isError = !0, t.isLoading = !1, t.isLoaded = !0, t.status = u.ERROR;
        break;
      }
      case w.GET_ENTITY_SUCCESS: {
        t.byId[o.payload.id] = o.payload.data;
        break;
      }
      case w.CREATE_ENTITY_PENDING:
        break;
      case w.CREATE_ENTITY_SUCCESS: {
        const { data: s, primaryKey: r, actions: n } = o.payload, a = s[r];
        t.isLoading = !1, t.ids.push(a), t.byId[a] = s, t.actions = n;
        break;
      }
      case w.CREATE_ENTITY_FAILURE:
        break;
      case w.DELETE_ENTITY_PENDING: {
        const { data: s, primaryKey: r } = o.payload, n = s[r];
        t.processingIds.push(n);
        break;
      }
      case w.DELETE_ENTITY_SUCCESS: {
        const { data: s, primaryKey: r } = o.payload, n = s[r];
        t.ids = t.ids.filter((a) => a !== n), t.processingIds = t.processingIds.filter(
          (a) => a !== n
        ), delete t.byId[n];
        break;
      }
      case w.DELETE_ENTITY_FAILURE:
        break;
      case w.GET_ALLOWED_SORTING_SUCCESS: {
        t.allowedSorting = o.payload.allowedSorting;
        break;
      }
    }
  });
}
const uo = {
  isLoading: !1,
  isLoaded: !1,
  isError: !1,
  byId: {},
  ids: [],
  actions: null,
  currentlyProcessingId: null,
  processingIds: [],
  status: u.INITIAL,
  pageCount: 1,
  pageNumber: 0,
  pageSize: 5,
  numberOfElements: 0,
  totalElements: 0,
  allowedSorting: [],
  rawData: []
};
function Hs(e) {
  const {
    primaryKey: o = "id",
    autoLoad: t = !1,
    async: s = !0,
    values: r = [],
    methods: n
  } = e, {
    read: a,
    get: l,
    create: A,
    update: _,
    delete: i,
    sort: T
  } = n || {}, [p, c] = W(
    _o,
    uo
  ), {
    isLoading: y,
    isLoaded: C,
    byId: O,
    ids: D,
    processingIds: I,
    isError: m,
    actions: f,
    status: Q
  } = p, $ = R(
    async (V, z) => {
      if (!(a != null && a.method) && s)
        throw Error('"Read" method is not defined.');
      if (!s) {
        c({
          type: w.GET_ENTITY_LIST_SUCCESS,
          payload: r
        });
        return;
      }
      try {
        c({
          type: w.GET_ENTITY_LIST_PENDING
        });
        const M = await a.method(V || {}), Ce = M.content || M, h = M.actions;
        c({
          type: w.GET_ENTITY_LIST_SUCCESS,
          payload: {
            data: z && typeof z == "function" ? z(Ce) : a.formatter && typeof a.formatter == "function" ? a.formatter(Ce) : Ce,
            actions: h,
            primaryKey: o,
            ...M
          }
        });
      } catch (M) {
        c({
          type: w.GET_ENTITY_LIST_FAILURE,
          payload: {
            err: M
          }
        });
      }
    },
    [s, ...s ? [] : [r], o]
  ), x = R(
    async (V, z = !1) => {
      if (!(A != null && A.method) && z)
        throw Error('"Create" method is not defined.');
      if (!z) {
        c({
          type: w.CREATE_ENTITY_SUCCESS,
          payload: {
            data: V,
            primaryKey: o
          }
        });
        return;
      }
      try {
        c({
          type: w.CREATE_ENTITY_PENDING,
          payload: {
            data: V,
            primaryKey: o
          }
        });
        const M = await (A == null ? void 0 : A.method(V));
        c({
          type: w.CREATE_ENTITY_SUCCESS,
          payload: {
            data: M,
            primaryKey: o
          }
        });
      } catch (M) {
        c({
          type: w.CREATE_ENTITY_FAILURE,
          payload: {
            err: M
          }
        });
      }
    },
    [o]
  ), B = R(async (V) => {
  }, []), v = R(async (V) => {
    if (!(l != null && l.method) && s)
      throw Error('"Get" method is not defined.');
    try {
      const z = await (l == null ? void 0 : l.method(V)), M = l == null ? void 0 : l.formatter([z]);
      c({
        type: w.GET_ENTITY_SUCCESS,
        payload: {
          id: z.id,
          data: M[0]
        }
      });
    } catch {
    }
  }, []), fe = R(
    async (V, z = !1) => {
      if (!(i != null && i.method) && z)
        throw Error('"Delete" method is not defined.');
      if (!z) {
        c({
          type: w.DELETE_ENTITY_SUCCESS,
          payload: {
            data: V,
            primaryKey: o
          }
        });
        return;
      }
      try {
        c({
          type: w.DELETE_ENTITY_PENDING,
          payload: {
            data: V,
            primaryKey: o
          }
        });
        const M = await (i == null ? void 0 : i.method(V));
        c({
          type: w.DELETE_ENTITY_SUCCESS,
          payload: {
            data: V,
            primaryKey: o
          }
        });
      } catch (M) {
        c({
          type: w.DELETE_ENTITY_FAILURE,
          payload: {
            err: M,
            data: V,
            primaryKey: o
          }
        });
      }
    },
    [o]
  ), Re = R(async () => {
    if (T)
      try {
        const V = await T.method();
        c({
          type: w.GET_ALLOWED_SORTING_SUCCESS,
          payload: {
            allowedSorting: V
          }
        });
      } catch {
        console.error("GET LIST SORTING: sth went wrong");
      }
  }, []);
  return b(() => {
    t && $({});
  }, [t]), b(() => {
    Re();
  }, [Re]), {
    ...p,
    processingIds: I,
    data: {
      byId: O,
      ids: D
    },
    getEntityList: $,
    createEntity: x,
    updateEntity: B,
    removeEntity: fe,
    getEntity: v
  };
}
const So = {
  content: null,
  props: {
    open: !1
  }
}, po = () => {
  const [e, o] = oe([]), t = R(
    (l, A, _) => {
      o((i) => [
        ...i,
        {
          content: l,
          title: A,
          props: { ..._, open: !0 }
        }
      ]);
    },
    []
  ), s = R(() => {
    o((l) => l.slice(0, -1));
  }, []), r = R((l) => {
    o((A) => A.slice(0, Math.max(0, A.length - l)));
  }, []), n = R(() => {
    o([]);
  }, []);
  return {
    ...e[e.length - 1] || So,
    modalCount: e.length,
    openModal: t,
    closeModal: s,
    closeAllModals: n,
    closeModals: r
  };
}, Ao = mt({
  openModal: () => {
  },
  closeModal: () => {
  },
  closeAllModals: () => {
  }
}), js = ({ children: e }) => {
  var O, D;
  const {
    openModal: o,
    closeModal: t,
    closeAllModals: s,
    closeModals: r,
    modalCount: n,
    ...a
  } = po(), l = _e(n), A = _e(n), _ = (I) => {
    const m = String(I || "").trim();
    return m && (m.startsWith("/") ? m : `/${m}`).replace(/\/+$/, "") || "/";
  };
  b(() => {
    const I = () => {
      s();
    };
    return window.addEventListener("prometheus:close-modal", I), () => {
      window.removeEventListener("prometheus:close-modal", I);
    };
  }, [s]), b(() => {
    l.current = n;
  }, [n]), b(() => {
    const I = () => {
      window.dispatchEvent(new Event("prometheus:location-change"));
    }, m = (x) => {
      const B = l.current, v = Pe("modal", x.state);
      v < B && r(B - v);
    }, f = window.history.pushState, Q = window.history.replaceState;
    window.history.pushState = function(...x) {
      const B = f.apply(this, x);
      return I(), B;
    }, window.history.replaceState = function(...x) {
      const B = Q.apply(this, x);
      return I(), B;
    };
    const $ = kt(m);
    return window.addEventListener("popstate", I), () => {
      window.history.pushState = f, window.history.replaceState = Q, $(), window.removeEventListener("popstate", I);
    };
  }, [r]), b(() => {
    const I = A.current;
    if (n > I)
      for (let m = I + 1; m <= n; m++)
        wt("modal", m);
    A.current = n;
  }, [n]);
  const i = R(() => {
    const I = l.current;
    if (!I)
      return;
    l.current = I - 1, A.current = I - 1, t(), Pe("modal") >= I && Be();
  }, [t]), T = R(() => {
    const I = l.current;
    if (!I)
      return;
    l.current = 0, A.current = 0, s(), Pe("modal") >= I && Be(I);
  }, [s]), p = Oe(
    () => ({
      openModal: o,
      closeModal: i,
      closeAllModals: T
    }),
    [T, i, o]
  );
  b(() => {
    const I = () => {
      var x, B;
      const m = (x = a == null ? void 0 : a.props) == null ? void 0 : x.closeOnRouteChangeOutside;
      if (!((B = a == null ? void 0 : a.props) != null && B.open) || !m)
        return;
      const f = _(window.location.pathname);
      (Array.isArray(m) ? m : [m]).map((v) => _(v)).filter(Boolean).some((v) => f === v || f.startsWith(`${v}/`)) || T();
    };
    return I(), window.addEventListener("prometheus:location-change", I), () => {
      window.removeEventListener(
        "prometheus:location-change",
        I
      );
    };
  }, [
    T,
    (O = a == null ? void 0 : a.props) == null ? void 0 : O.closeOnRouteChangeOutside,
    (D = a == null ? void 0 : a.props) == null ? void 0 : D.open
  ]);
  const c = (...I) => {
    if (a.props.onClose) {
      a.props.onClose(...I);
      return;
    }
    i();
  }, y = typeof a.props.width == "number" ? `${a.props.width}px` : a.props.width, C = () => {
    const I = a;
    if (I) {
      const { content: m, title: f } = I;
      return m ? /* @__PURE__ */ ne.jsxs(ne.Fragment, { children: [
        f && /* @__PURE__ */ ne.jsx(eo, { onClose: c, children: f }),
        /* @__PURE__ */ ne.jsx(m, {})
      ] }) : /* @__PURE__ */ ne.jsx(ne.Fragment, {});
    }
  };
  return /* @__PURE__ */ ne.jsx("div", { children: /* @__PURE__ */ ne.jsxs(Ao.Provider, { value: p, children: [
    e,
    /* @__PURE__ */ ne.jsx(
      Jt,
      {
        open: a.props.open,
        onClose: c,
        closeOnClickOutside: a.props.closeOnClickOutside,
        collapsible: a.props.collapsible,
        width: y,
        children: C()
      }
    )
  ] }) });
};
var he = /* @__PURE__ */ ((e) => (e.GET_STUDY_TYPE = "GET_STUDY_TYPE", e.SET_STUDY_TYPE_SUCCESS = "SET_STUDY_TYPE_SUCCESS", e.SET_STUDY_TYPE_ERROR = "SET_STUDY_TYPE_ERROR", e))(he || {});
const Io = {
  studyTypes: {
    isLoading: !1,
    data: [],
    error: null
  }
}, Ro = (e, o) => Ue(e, (t) => {
  switch (o.type) {
    case he.GET_STUDY_TYPE:
      t.isLoading = !0, t.error = null;
      break;
    case he.SET_STUDY_TYPE_SUCCESS:
      t.isLoading = !1, t.studyTypes.data = o.payload;
      break;
    case he.SET_STUDY_TYPE_ERROR:
      t.isLoading = !1, t.error = o.payload;
      break;
  }
}), Ws = (e) => {
  const [o, t] = W(Ro, Io), s = R(async () => {
    t({
      type: he.GET_STUDY_TYPE
    });
    try {
      const r = await e();
      t({
        type: he.SET_STUDY_TYPE_SUCCESS,
        payload: r.content
      });
    } catch (r) {
      console.error("STUDY TYPES ERROR", r), t({
        type: he.SET_STUDY_TYPE_ERROR,
        payload: r
      });
    }
  }, []);
  return {
    ...o,
    getTypesOfStudy: s
  };
}, zs = ht.createContext({});
var Ee = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.ADD_SECTION = "ADD_SECTION", e.COPY_SECTION = "COPY_SECTION", e.REMOVE_SECTION = "REMOVE_SECTION", e.UPDATE_SECTION = "UPDATE_SECTION", e.MOVE_SECTION = "MOVE_SECTION", e))(Ee || {});
const yo = (e, o) => Ue(e, (t) => {
  switch (o.type) {
    case Ee.INIT:
      t.sections = o.payload, t.status = u.SUCCESS, t.isStartHook = !0;
      break;
    case Ee.ADD_SECTION:
      t.sections = t.sections.map((s) => ({
        ...s,
        defaultState: !1
      })), t.sections.push({ ...o.payload, defaultState: !0 });
      break;
    case Ee.COPY_SECTION:
      t.sections = t.sections.map((s) => ({
        ...s,
        defaultState: !1
      })), t.sections.splice(o.payload.id, 0, {
        ...o.payload.section,
        defaultState: !0
      });
      break;
    case Ee.UPDATE_SECTION:
      o.payload.id >= 0 && t.sections.splice(o.payload.id, 1, o.payload.section);
      break;
    case Ee.REMOVE_SECTION:
      t.sections.splice(o.payload, 1);
      break;
    case Ee.MOVE_SECTION: {
      const { from: s, to: r } = o.payload, n = t.sections.length;
      if (s === r || s < 0 || r < 0 || s >= n || r >= n)
        break;
      const [a] = t.sections.splice(s, 1);
      t.sections.splice(r, 0, a);
      break;
    }
  }
}), Co = {
  sections: [],
  isStartHook: !1,
  isLoading: !1,
  status: u.INITIAL
}, Oo = (e) => {
  const o = Je(e);
  let t = bt();
  for (; o[t]; )
    t += 1;
  return t;
}, qs = (e) => {
  const [o, t] = W(
    yo,
    Co
  ), s = R(() => {
    t({
      type: Ee.INIT,
      payload: e
    });
  }, []), r = R((_) => {
    const i = {
      id: bt(),
      name: (_ == null ? void 0 : _.name) || "New section",
      description: (_ == null ? void 0 : _.description) || "",
      expression: (_ == null ? void 0 : _.expression) || {}
    };
    t({
      type: Ee.ADD_SECTION,
      payload: i
    });
  }, []), n = R(
    (_) => {
      const i = o.sections[_], T = Oo(
        o.sections
      );
      t({
        type: Ee.COPY_SECTION,
        payload: {
          id: _ + 1,
          section: {
            ...i,
            id: T,
            name: `Copy of: ${i.name}`
          }
        }
      });
    },
    [o]
  ), a = R((_) => {
    t({
      type: Ee.REMOVE_SECTION,
      payload: _
    });
  }, []), l = R(
    (_, i, T) => {
      const p = o.sections[_];
      t({
        type: Ee.UPDATE_SECTION,
        payload: {
          section: {
            ...p,
            [i]: T
          },
          id: _
        }
      });
    },
    [o]
  ), A = R((_, i) => {
    t({
      type: Ee.MOVE_SECTION,
      payload: { from: _, to: i }
    });
  }, []);
  return b(() => {
    e && s();
  }, []), {
    ...o,
    addSection: r,
    removeSection: a,
    updateSection: l,
    copySection: n,
    moveSection: A
  };
};
var Ae = /* @__PURE__ */ ((e) => (e.INIT = "INIT", e.ADD_SECTION = "ADD_SECTION", e.COPY_SECTION = "COPY_SECTION", e.REMOVE_SECTION = "REMOVE_SECTION", e.UPDATE_SECTION = "UPDATE_SECTION", e))(Ae || {});
const No = (e, o) => Ue(e, (t) => {
  var s;
  switch (o.type) {
    case Ae.INIT:
      t.sections = o.payload, t.ids = Je(o.payload), t.status = u.SUCCESS;
      break;
    case Ae.ADD_SECTION:
      t.sections = t.sections.map((r) => ({
        ...r,
        defaultState: !1
      })), t.sections.push({ ...o.payload, defaultState: !0 }), t.ids[o.payload.id] = !0;
      break;
    case Ae.COPY_SECTION: {
      const { index: r, section: n } = o.payload, a = {
        ...n,
        defaultState: !0
      };
      t.sections = t.sections.map((l) => ({
        ...l,
        defaultState: !1
      })), t.sections.splice(r + 1, 0, a), t.ids[n.id] = !0;
      break;
    }
    case Ae.UPDATE_SECTION:
      if (o.payload.index >= 0) {
        const { index: r, field: n, value: a } = o.payload, l = { ...t.sections[r], [n]: a };
        t.sections.splice(o.payload.index, 1, l);
      }
      break;
    case Ae.REMOVE_SECTION: {
      const r = (s = t.sections[o.payload]) == null ? void 0 : s.id;
      t.sections.splice(o.payload, 1), delete t.ids[r];
      break;
    }
  }
}), Lo = {
  sections: [],
  status: u.INITIAL,
  ids: {}
}, We = (e) => (e || "").trim().toLowerCase(), St = (e, o = []) => {
  const t = We(e);
  if (!t)
    return e;
  const s = new Set(
    o.map((a) => We(a == null ? void 0 : a.name))
  );
  if (!s.has(t))
    return e;
  let r = 1, n = `${e} (${r})`;
  for (; s.has(We(n)); )
    r += 1, n = `${e} (${r})`;
  return n;
}, Xs = (e) => {
  const [o, t] = W(No, {
    ...Lo,
    sections: e,
    ids: Je(e)
  }), { enqueueSnackbar: s } = Pt(), r = (i) => {
    try {
      const T = at(o.ids), p = ((i == null ? void 0 : i.name) || "New section").trim() || "New section", c = St(p, o.sections), y = {
        ...i,
        id: T,
        name: c,
        description: (i == null ? void 0 : i.description) || "",
        expression: (i == null ? void 0 : i.expression) || {}
      };
      t({
        type: Ae.ADD_SECTION,
        payload: y
      });
    } catch {
      s({
        message: "Concept Set limit exceeded (100 items)",
        variant: "error"
      });
    }
  }, n = (i) => {
    try {
      const T = at(o.ids), p = `Copy of ${o.sections[i].name}`.trim(), c = St(p, o.sections), y = {
        ...o.sections[i],
        name: c,
        id: T
      };
      t({
        type: Ae.COPY_SECTION,
        payload: { index: i, section: y }
      });
    } catch {
      s({
        message: "Concept Set limit exceeded (100 items)",
        variant: "error"
      });
    }
  }, a = (i) => {
    t({
      type: Ae.REMOVE_SECTION,
      payload: i
    });
  }, l = R((i) => {
    t({
      type: Ae.INIT,
      payload: i
    });
  }, []), A = R(
    (i, T, p) => {
      t({
        type: Ae.UPDATE_SECTION,
        payload: {
          field: T,
          value: p,
          index: i
        }
      });
    },
    [o]
  ), _ = R(
    (i) => o.sections[i],
    [o.sections]
  );
  return {
    ...o,
    addSection: r,
    removeSection: a,
    updateSection: A,
    copySection: n,
    exportSection: _,
    syncSections: l
  };
}, Do = {
  selectedConcepts: {}
};
var ae = /* @__PURE__ */ ((e) => (e.ADD_SELECTED_CONCEPT = "ADD_SELECTED_CONCEPT", e.REMOVE_SELECTED_CONCEPT = "REMOVE_SELECTED_CONCEPT", e.ADD_ALL_SELECTED_ELEMENT = "ADD_ALL_SELECTED_ELEMENT", e.REMOVE_ALL_SELECTED_ELEMENT = "REMOVE_ALL_SELECTED_ELEMENT", e.UPDATE_SELECTED_CONCEPT = "UPDATE_SELECTED_CONCEPT", e.UPDATE_SELECTED_CONCEPT_BULK = "UPDATE_SELECTED_CONCEPT_BULK", e.INIT = "INIT", e.CLEAR = "CLEAR", e))(ae || {});
const ho = (e, o) => Ue(e, (t) => {
  switch (o.type) {
    case ae.INIT:
      t.selectedConcepts = o.payload;
      break;
    case ae.CLEAR:
      t.selectedConcepts = {};
      break;
    case ae.ADD_SELECTED_CONCEPT:
      {
        const { concept: r, id: n } = o.payload;
        t.selectedConcepts[r[n]] = r;
      }
      break;
    case ae.UPDATE_SELECTED_CONCEPT:
      {
        const { concept: r, id: n } = o.payload;
        t.selectedConcepts[r[n]] = r;
      }
      break;
    case ae.UPDATE_SELECTED_CONCEPT_BULK: {
      const { rows: r, accessor: n } = o.payload;
      for (const a of r)
        t.selectedConcepts[a.row[n]] && (t.selectedConcepts[a.row[n]][a.columnId] = a.value);
      break;
    }
    case ae.REMOVE_SELECTED_CONCEPT:
      {
        const { concept: r, id: n } = o.payload;
        delete t.selectedConcepts[r[n]];
      }
      break;
    case ae.ADD_ALL_SELECTED_ELEMENT:
      const s = {
        ...t.selectedConcepts,
        ...o.payload.rows
      };
      o.payload.ids && Object.keys(s).forEach((r) => {
        o.payload.ids[r] || delete s[r];
      }), t.selectedConcepts = s;
      break;
    case ae.REMOVE_ALL_SELECTED_ELEMENT:
      {
        const { concepts: r, id: n } = o.payload;
        r.forEach((a) => {
          delete t.selectedConcepts[a[n]];
        });
      }
      break;
  }
}), Ks = (e, o = "conceptId") => {
  const [t, s] = W(
    ho,
    Do
  ), r = () => {
    s({
      type: ae.CLEAR
    });
  }, n = (_) => {
    s({
      type: ae.INIT,
      payload: _
    });
  }, a = (_, i) => {
    s({
      type: ae.ADD_ALL_SELECTED_ELEMENT,
      payload: { rows: _, ids: i }
    });
  }, l = (_) => {
    s({
      type: ae.UPDATE_SELECTED_CONCEPT,
      payload: {
        id: o,
        concept: _
      }
    });
  }, A = (_) => {
    s({
      type: ae.UPDATE_SELECTED_CONCEPT_BULK,
      payload: {
        accessor: o,
        rows: _
      }
    });
  };
  return b(() => {
    e && Object.keys(e).length && n(e);
  }, []), {
    ...t,
    clear: r,
    init: n,
    detectSelectedAction: a,
    updateSelectedConcept: l,
    updateSelectedConceptBulk: A
  };
};
function Zs(e, o) {
  const t = _e(null);
  b(() => {
    t.current = e;
  }, [e]), b(() => {
    function s() {
      t.current();
    }
    if (o !== null) {
      let r = setInterval(s, o);
      return () => clearInterval(r);
    }
  }, [o]);
}
function Js(e, o, t = 1e3, s) {
  const r = _e(e), n = _e(null), a = _e(s);
  return b(() => {
    r.current = e, a.current = s;
  }, [e, s]), b(() => {
    if (t !== null)
      return n.current = setInterval(() => {
        r.current(), o() && (n.current && (clearInterval(n.current), n.current = null), a.current && a.current());
      }, t), () => {
        n.current && clearInterval(n.current);
      };
  }, [t, o]), R(() => {
    n.current && clearInterval(n.current);
  }, []);
}
var te = /* @__PURE__ */ ((e) => (e.LOAD_METADATA_REQUEST = "LOAD_METADATA_REQUEST", e.LOAD_METADATA_REQUEST_DONE = "LOAD_METADATA_REQUEST_DONE", e.LOAD_METADATA_REQUEST_FAILED = "LOAD_METADATA_REQUEST_FAILED", e.ADD_ATTRIBUTE_REQUEST = "ADD_ATTRIBUTE_REQUEST", e.ADD_ATTRIBUTE_REQUEST_DONE = "ADD_ATTRIBUTE_REQUEST_DONE", e.UPDATE_ATTRIBUTE = "UPDATE_ATTRIBUTE", e.UPDATE_ATTRIBUTES_SETTINGS = "UPDATE_ATTRIBUTES_SETTINGS", e.REMOVE_ATTRIBUTE = "REMOVE_ATTRIBUTE", e))(te || {});
const mo = {
  isLoading: !1,
  status: u.INITIAL,
  data: [],
  pageCount: 1,
  pageNumber: 0,
  pageSize: 10,
  numberOfElements: 0,
  totalElements: 0,
  changeMessage: null
}, Uo = (e, o) => Ie(e, (t) => {
  switch (o.type) {
    case te.LOAD_METADATA_REQUEST:
      t.isLoading = !0, t.status = u.IN_PROGRESS;
      break;
    case te.LOAD_METADATA_REQUEST_DONE:
      t.isLoading = !1, t.status = u.SUCCESS, t.data = o.payload.content;
      break;
    case te.LOAD_METADATA_REQUEST_FAILED:
      t.isLoading = !1, t.status = u.ERROR;
      break;
    case te.ADD_ATTRIBUTE_REQUEST:
      t.changeMessage = null, t.isLoading = !0;
      break;
    case te.ADD_ATTRIBUTE_REQUEST_DONE:
      t.isLoading = !1, t.data.push(o.payload), t.changeMessage = `Create attribute ${o.payload.name}`;
      break;
    case te.UPDATE_ATTRIBUTE:
      const s = t.data.findIndex(
        (n) => n.id === o.payload.id
      );
      t.data[s] = o.payload, t.isLoading = !1, t.changeMessage = `Update attribute ${o.payload.name}`;
      break;
    case te.REMOVE_ATTRIBUTE:
      const r = t.data.findIndex(
        (n) => n.id === o.payload
      );
      t.data.splice(r, 1), t.changeMessage = "Remove attribute";
      break;
  }
}), bo = (e, o = "") => {
  const { pageNumber: t = 0, pageSize: s = 10, sortBy: r, query: n = "" } = e, a = gt(r), l = `/admin/metadata-attribute/list?${n}&size=${s}&page=${t}&sort=${a}${o}`;
  return Z.get(l);
}, pt = (e) => {
  const o = e == null ? void 0 : e.toLowerCase();
  return !!(o != null && o.startsWith("ai-") && o !== "ai-generated");
}, go = (e, o) => e.filter(
  ({ name: t }) => o ? pt(t) : !pt(t)
), er = (e, o, t, s, r, n) => {
  const [a, l] = W(
    Uo,
    mo
  ), A = R(async () => {
    l({
      type: te.LOAD_METADATA_REQUEST
    });
    try {
      const c = await bo(
        {
          pageNumber: 0,
          pageSize: 1e6
        },
        e
      );
      l({
        type: te.LOAD_METADATA_REQUEST_DONE,
        payload: t ? c : { ...c, content: go(c.content, o) }
      });
    } catch {
    }
  }, [e, o, t]), _ = R(
    async (c) => {
      l({
        type: te.ADD_ATTRIBUTE_REQUEST
      });
      const y = {
        id: c.id,
        name: c.title,
        type: c.type,
        options: c.options,
        required: !1,
        filterable: !1,
        searchable: !1,
        visible: !1,
        metadataSubjects: c.metadataSubjects
      };
      try {
        const C = await s(y);
        l({
          type: te.ADD_ATTRIBUTE_REQUEST_DONE,
          payload: C
        });
      } catch {
      }
    },
    [a]
  ), i = R(
    async (c, y) => {
      l({
        type: te.ADD_ATTRIBUTE_REQUEST
      });
      const C = {
        id: y.id,
        name: c.title,
        type: c.type,
        options: c.options,
        required: y.required,
        filterable: y.filterable,
        searchable: y.searchable,
        visible: y.visible,
        metadataSubjects: c.metadataSubjects
      };
      try {
        const O = await r(C.id, C);
        l({
          type: te.UPDATE_ATTRIBUTE,
          payload: O
        });
      } catch {
      }
    },
    [a]
  ), T = R(
    async (c) => {
      const y = {
        ...a.data[c.rowIndex],
        [c.columnId]: c.value
      };
      try {
        const C = await r(y.id, y);
        l({
          type: te.UPDATE_ATTRIBUTE,
          payload: C
        });
      } catch {
      }
    },
    [a.data]
  ), p = R(async (c) => {
    try {
      await n(c), l({
        type: te.REMOVE_ATTRIBUTE,
        payload: c
      });
    } catch {
    }
  }, []);
  return b(() => {
    A();
  }, [o]), {
    ...a,
    getMetadata: A,
    addAttribute: _,
    updateAttribute: i,
    editAttribute: T,
    removeAttribute: p
  };
};
var pe = /* @__PURE__ */ ((e) => (e.GET_VERIONS_LIST_REQUEST = "GET_VERIONS_LIST_REQUEST", e.GET_VERIONS_LIST_REQUEST_DONE = "GET_VERIONS_LIST_REQUEST_DONE", e.GET_VERIONS_LIST_REQUEST_FAILED = "GET_VERIONS_LIST_REQUEST_FAILED", e.GET_CURRENT_VERSION_REQUEST = "GET_CURRENT_VERSION_REQUEST", e.GET_CURRENT_VERSION_REQUEST_DONE = "GET_CURRENT_VERSION_REQUEST_DONE", e.GET_CURRENT_VERSION_REQUEST_FAILED = "GET_CURRENT_VERSION_REQUEST_FAILED", e))(pe || {});
const Po = (e, o) => Ie(e, (t) => {
  switch (o.type) {
    case pe.GET_VERIONS_LIST_REQUEST:
      t.isLoading = !0;
      break;
    case pe.GET_VERIONS_LIST_REQUEST_DONE:
      t.isStartHook = !0, t.isLoading = !1, t.versions = o.payload.versions, t.totalElements = o.payload.totalElements;
      break;
    case pe.GET_CURRENT_VERSION_REQUEST_DONE:
      t.currentVersion = o.payload;
  }
}), fo = {
  versions: [],
  currentVersion: null,
  isStartHook: !1,
  isLoading: !1,
  error: null,
  totalElements: 0
}, tr = (e, o, t, s, r, n) => {
  const [a, l] = W(
    Po,
    fo
  ), A = R(async () => {
    if (l({
      type: pe.GET_VERIONS_LIST_REQUEST
    }), !e)
      return l({
        type: pe.GET_VERIONS_LIST_REQUEST_DONE,
        payload: []
      }), 0;
    try {
      const T = await t(e);
      l({
        type: pe.GET_VERIONS_LIST_REQUEST_DONE,
        payload: {
          versions: Kt(
            T.content,
            o,
            n
          ),
          totalElements: T.totalElements
        }
      });
    } catch {
      l({
        type: pe.GET_VERIONS_LIST_REQUEST_FAILED
      });
    }
  }, []), _ = R(async (T) => {
    var p, c, y, C, O, D;
    l({
      type: pe.GET_CURRENT_VERSION_REQUEST
    });
    try {
      const I = await s(T);
      l({
        type: pe.GET_CURRENT_VERSION_REQUEST_DONE,
        payload: {
          ...I.data,
          name: `${((p = I.data) == null ? void 0 : p.name) || ((c = I.data) == null ? void 0 : c.title)} (Version #${I.ordinal})`,
          title: `${((y = I.data) == null ? void 0 : y.name) || ((C = I.data) == null ? void 0 : C.title)} (Version #${I.ordinal})`,
          originName: `${((O = I.data) == null ? void 0 : O.name) || ((D = I.data) == null ? void 0 : D.title)}`,
          versionId: I.id
        }
      });
    } catch {
      l({
        type: pe.GET_CURRENT_VERSION_REQUEST_FAILED
      });
    }
  }, []), i = R(async (T) => {
    try {
      const p = await s(T);
      r(p.data);
    } catch {
    }
  }, []);
  return b(() => {
    A();
  }, []), {
    ...a,
    getCurrentVersion: _,
    getListVersions: A,
    copyVersion: i
  };
};
var X = /* @__PURE__ */ ((e) => (e.GET_VALUES_REQUEST = "GET_VALUES_REQUEST", e.GET_VALUES_REQUEST_DONE = "GET_VALUES_REQUEST_DONE", e.GET_VALUES_REQUEST_FAILED = "GET_VALUES_REQUEST_FAILED", e.CREATE_VALUE = "CREATE_VALUE", e.UPDATE_VALUE = "UPDATE_VALUE", e.DELETE_VALUE = "DELETE_VALUE", e.CHANGE_VALUE_REQUEST = "CHANGE_VALUE_REQUEST", e.CHANGE_VALUE_REQUEST_DONE = "CHANGE_VALUE_REQUEST_DONE", e.CHANGE_VALUE_REQUEST_FAILED = "CHANGE_VALUE_REQUEST_FAILED", e.CREATE_VALUE_REQUEST = "CREATE_VALUE_REQUEST", e.CREATE_VALUE_REQUEST_DONE = "CREATE_VALUE_REQUEST_DONE", e.CREATE_VALUE_REQUEST_FAILED = "CREATE_VALUE_REQUEST_FAILED", e.COPY_VALUE_REQUEST = "COPY_VALUE_REQUEST", e.COPY_VALUE_REQUEST_DONE = "COPY_VALUE_REQUEST_DONE", e.COPY_VALUE_REQUEST_FAILED = "COPY_VALUE_REQUEST_FAILED", e))(X || {}), Se = /* @__PURE__ */ ((e) => (e.INITIAL = "INITIAL", e.LOADING_METADATA = "LOADING_METADATA", e.LOADED_METADATA = "LOADED_METADATA", e.ERROR_LOADED_METADATA = "ERROR_LOADED_METADATA", e.LOADING_CREATE_METADATA = "LOADING_CREATE_METADATA", e.LOADED_CREATE_METADATA = "LOADED_CREATE_METADATA", e.ERROR_LOADED_CREATE_METADATA = "ERROR_LOADED_CREATE_METADATA", e.LOADING_COPY_METADATA = "LOADING_COPY_METADATA", e.LOADED_COPY_METADATA = "LOADED_COPY_METADATA", e.ERROR_LOADED_COPY_METADATA = "ERROR_LOADED_COPY_METADATA", e))(Se || {});
const vo = (e, o) => Ie(e, (t) => {
  switch (o.type) {
    case X.GET_VALUES_REQUEST:
      t.status = Se.LOADING_METADATA;
      break;
    case X.GET_VALUES_REQUEST_DONE:
      t.values = o.payload, t.status = Se.LOADED_METADATA;
      break;
    case X.GET_VALUES_REQUEST_FAILED:
      t.values = [], t.status = Se.ERROR_LOADED_METADATA, t.error = o.payload;
      break;
    case X.CREATE_VALUE_REQUEST:
      t.status = Se.LOADING_CREATE_METADATA;
      break;
    case X.CREATE_VALUE_REQUEST_DONE:
      t.status = Se.LOADED_CREATE_METADATA, t.values = o.payload;
      break;
    case X.CREATE_VALUE_REQUEST_FAILED:
      t.status = Se.ERROR_LOADED_CREATE_METADATA, t.values = [], t.error = o.payload;
      break;
    case X.COPY_VALUE_REQUEST:
      t.status = Se.LOADING_COPY_METADATA;
      break;
    case X.COPY_VALUE_REQUEST_DONE:
      t.status = Se.LOADED_COPY_METADATA;
      break;
    case X.COPY_VALUE_REQUEST_FAILED:
      t.status = Se.ERROR_LOADED_COPY_METADATA, t.error = o.payload;
      break;
  }
}), wo = {
  values: [],
  isStartHook: !1,
  isLoading: !1,
  error: null,
  status: Se.INITIAL
}, At = (e) => {
  const o = e == null ? void 0 : e.toLowerCase();
  return !!(o != null && o.startsWith("ai-") && o !== "ai-generated");
}, It = (e, o) => e.filter(
  ({ attribute: t }) => o ? At(t == null ? void 0 : t.name) : !At(t == null ? void 0 : t.name)
), or = (e, o, t) => {
  const [s, r] = W(
    vo,
    wo
  ), {
    entityFilter: n,
    getListValues: a,
    updateMetadataValue: l,
    removeMetadataValue: A,
    createMetadataValue: _,
    copyMetadataValue: i
  } = o, T = R(
    async (y) => {
      r({
        type: X.GET_VALUES_REQUEST
      });
      try {
        const C = await a(
          `filter.metadata.value.${n}.id`,
          y
        );
        r({
          type: X.GET_VALUES_REQUEST_DONE,
          payload: It(C.content, t)
        });
      } catch {
      }
    },
    [t, n, a]
  ), p = R(
    async (y, C) => {
      r({
        type: X.CREATE_VALUE_REQUEST
      });
      const O = [];
      Object.keys(y).forEach((D) => {
        const I = y[D], m = C[D];
        (m.type === Ve.STRING || m.type === Ve.INTEGER) && (I.values.valueId ? I.values.value ? O.push(
          l(
            {
              attribute: {
                id: I.attributeId
              },
              dataSourceId: I.dataSourceId,
              value: I.values.value
            },
            I.values.valueId
          )
        ) : O.push(A(I.values.valueId)) : I.values.value && O.push(
          _({
            attribute: {
              id: I.attributeId
            },
            dataSourceId: I.dataSourceId,
            value: I.values.value
          })
        )), (m.type === Ve.ENUM || m.type === Ve.ENUM_MULTI) && (I.values.forEach((f) => {
          m.values.find(
            ($) => $.attributeOption.id === f.optionId
          ) || O.push(
            _({
              attribute: {
                id: I.attributeId
              },
              attributeOption: {
                id: f.optionId,
                value: f.value
              },
              dataSourceId: I.dataSourceId
            })
          );
        }), m.values.forEach((f) => {
          I.values.find(
            ($) => $.optionId === f.attributeOption.id
          ) || O.push(A(f.id));
        }));
      });
      try {
        await Promise.all(O);
        const D = await a(
          `filter.metadata.value.${n}.id`,
          e
        );
        r({
          type: X.CREATE_VALUE_REQUEST_DONE,
          payload: It(D.content, t)
        });
      } catch {
      }
    },
    [
      t,
      _,
      n,
      e,
      a,
      A,
      l
    ]
  ), c = R(
    async (y, C) => {
      r({
        type: X.COPY_VALUE_REQUEST
      });
      try {
        return await i(y, {
          targetIds: C.map((O) => O.id)
        }), r({
          type: X.COPY_VALUE_REQUEST_DONE
        }), !0;
      } catch (O) {
        return r({
          type: X.COPY_VALUE_REQUEST_FAILED,
          payload: O
        }), !1;
      }
    },
    [i]
  );
  return b(() => {
    T(e);
  }, [e, T]), {
    ...s,
    saveMetadataValue: p,
    getMetadataValues: T,
    copyMetadataValues: c
  };
}, ko = {
  entity: null,
  actions: {},
  version: null,
  draft: null,
  isVersionMode: !1,
  status: u.INITIAL,
  error: null
}, Fo = (e, o, t) => {
  const { enqueueSnackbar: s } = Pt(), [r, n] = W(
    Go,
    ko
  ), a = R(async () => {
    n({
      type: "GET_ENTITY"
      /* GET_ENTITY */
    });
    try {
      let c = await e.get(o);
      n({
        type: "GET_ENTITY_SUCCESS",
        payload: { data: c }
      });
    } catch (c) {
      n({
        type: "GET_ENTITY_ERROR",
        payload: { error: c }
      });
    }
  }, [o]), l = R(async () => {
    n({
      type: "DELETE_ENTITY"
      /* DELETE_ENTITY */
    });
    try {
      let c = await e.delete(o);
      n({
        type: "DELETE_ENTITY_SUCCESS",
        payload: { data: c }
      }), s({
        message: (t || "Entity") + " deleted successfully.",
        variant: "success"
      });
    } catch (c) {
      n({
        type: "DELETE_ENTITY_ERROR",
        payload: { error: c }
      }), s({
        message: "Something went wrong. " + c.message,
        variant: "error"
      });
    }
  }, [o]), A = R(
    async (c) => {
      n({
        type: "UPDATE_ENTITY"
        /* UPDATE_ENTITY */
      });
      try {
        let y = await e.update(c, o);
        n({
          type: "UPDATE_ENTITY_SUCCESS",
          payload: { data: y }
        }), s({
          message: (t || "Entity") + " updated successfully.",
          variant: "success"
        });
      } catch (y) {
        console.error(y), n({
          type: "UPDATE_ENTITY_ERROR",
          payload: { error: y }
        }), s({
          message: "Something went wrong. " + y.message,
          variant: "error"
        });
      }
    },
    [o]
  ), _ = R(
    async (c) => {
      n({
        type: "COPY_ENTITY"
        /* COPY_ENTITY */
      });
      try {
        let y = await e.copy(
          c.id,
          `Copy of ${c.name || c.title}`
        );
        return n({
          type: "UPDATE_ENTITY_SUCCESS",
          payload: { data: y }
        }), s({
          message: (t || "Entity") + " copied successfully.",
          variant: "success"
        }), y;
      } catch (y) {
        n({
          type: "UPDATE_ENTITY_ERROR",
          payload: { error: y }
        }), s({
          message: "Something went wrong. " + y.message,
          variant: "error"
        });
      }
    },
    [o]
  ), i = R(
    (c) => {
      n({
        type: "SET_VERSION",
        payload: {
          ...c,
          revertVersionId: c.versionId,
          versionId: r.draft.versionId
        }
      });
    },
    [r.draft]
  ), T = (c) => {
    n({
      type: "NON_PERSIST_UPDATE",
      payload: c
    });
  }, p = () => {
    n({
      type: "REVERT_VERSION"
      /* REVERT_VERSION */
    });
  };
  return b(() => {
    o != "new" && a();
  }, [o]), {
    ...r,
    getEntity: a,
    copyEntity: _,
    deleteEntity: l,
    updateEntity: A,
    setVersionEntity: i,
    revertEntity: p,
    noPersistUpdate: T
  };
}, Go = (e, o) => Ue(e, (t) => {
  var s, r;
  switch (o.type) {
    case "GET_ENTITY":
      t.status = e.status === u.INITIAL ? u.IN_PROGRESS : u.IN_PROGRESS_RELOAD;
      break;
    case "GET_ENTITY_SUCCESS":
      if (o.payload.data == null) {
        t.error = { message: "Not found" }, t.status = u.ERROR;
        break;
      }
      t.entity = o.payload.data, t.draft = o.payload.data, t.actions = je((s = o.payload.data) == null ? void 0 : s.actions), t.status = u.SUCCESS;
      break;
    case "GET_ENTITY_ERROR":
      t.error = { ...o.payload.error, message: "Not found" }, t.status = u.ERROR;
      break;
    case "DELETE_ENTITY":
      t.status = u.IN_PROGRESS;
      break;
    case "DELETE_ENTITY_SUCCESS":
      t.status = u.SUCCESS;
      break;
    case "DELETE_ENTITY_ERROR":
      t.status = u.ERROR;
      break;
    case "UPDATE_ENTITY":
      t.status = u.IN_PROGRESS_RELOAD;
      break;
    case "UPDATE_ENTITY_SUCCESS":
      t.isVersionMode = !1, t.version = null, t.entity = o.payload.data, t.actions = je((r = o.payload.data) == null ? void 0 : r.actions), t.draft = o.payload.data, t.status = u.SUCCESS;
      break;
    case "UPDATE_ENTITY_ERROR":
      t.status = u.ERROR;
      break;
    case "NON_PERSIST_UPDATE":
      t.entity = o.payload, t.draft = o.payload, t.actions = je(o.payload.actions);
      break;
    case "SET_VERSION":
      t.version = o.payload, t.draft = o.payload, t.isVersionMode = !0;
      break;
    case "REVERT_VERSION":
      t.version = null, t.isVersionMode = !1, t.draft = t.entity;
      break;
  }
});
var j = /* @__PURE__ */ ((e) => (e.SET_DESIGN = "SET_DESIGN", e.SET_DESIGN_SUCCESS = "SET_DESIGN_SUCCESS", e.SET_DESIGN_ERROR = "SET_DESIGN_ERROR", e.UPDATE_DESIGN = "UPDATE_DESIGN", e.UPDATE_DESIGN_BASE = "UPDATE_DESIGN_BASE", e.SAVE_DESIGN = "SAVE_DESIGN", e.SAVE_DESIGN_SUCCESS = "SAVE_DESIGN_SUCCESS", e.SAVE_DESIGN_ERROR = "SAVE_DESIGN_ERROR", e.RELOAD_DESIGN_SUCCESS = "RELOAD_DESIGN_SUCCESS", e.GET_SUMMARY = "GET_SUMMARY", e))(j || {});
const Yo = {
  design: null,
  designStatus: u.INITIAL,
  designError: null,
  summary: {}
  // analysisTypeData: {},
}, Vo = (e, o) => Ie(e, (t) => {
  switch (o.type) {
    case j.SET_DESIGN:
      t.designStatus = u.IN_PROGRESS, t.designError = null, t.design = null;
      break;
    case j.RELOAD_DESIGN_SUCCESS:
      t.design = {
        ...t.design,
        design: o.payload
      };
      break;
    case j.SET_DESIGN_SUCCESS:
      t.designStatus = u.SUCCESS, t.design = o.payload;
      break;
    case j.SET_DESIGN_ERROR:
      t.designStatus = u.ERROR, t.designError = o.payload;
      break;
    case j.UPDATE_DESIGN:
      t.design.design[o.payload.key] = o.payload.value;
      break;
    case j.UPDATE_DESIGN_BASE:
      t.design = {
        ...t.design,
        ...o.payload
      };
      break;
    case j.SAVE_DESIGN:
      t.designStatus = u.IN_PROGRESS;
      break;
    case j.SAVE_DESIGN_SUCCESS:
      t.designStatus = u.SUCCESS;
      break;
    case j.GET_SUMMARY:
      t.summary = o.payload;
      break;
    case j.SAVE_DESIGN_ERROR:
      t.designStatus = u.ERROR;
      break;
  }
});
function Rt(e, o) {
  return {
    name: e.name,
    description: e.description || void 0,
    expression: {
      items: Object.values(o).map((t) => {
        const { id: s, ...r } = t, n = t.excluded ?? t.isExcluded;
        return {
          ...r,
          concept: null,
          isExcluded: n ?? !1,
          excluded: n ?? !1,
          hierarchy: t.hierarchy ?? !1,
          includeDescendants: t.includeDescendants ?? !1,
          includeMapped: t.includeMapped ?? !1
        };
      })
    }
  };
}
const Gt = ["bt", "!bt"], Yt = (e) => {
  switch (e) {
    case "lt":
    case "lte":
    case "eq":
    case "gt":
    case "gte":
    case "bt":
    case "!bt":
      return e;
    case "<":
    case "less than":
      return "lt";
    case "<=":
    case "less or equal to":
      return "lte";
    case "=":
    case "equal to":
      return "eq";
    case ">":
    case "greater than":
      return "gt";
    case ">=":
    case "greater or equal to":
      return "gte";
    case "between":
    case "beetwen":
      return "bt";
    case "not between":
    case "not beetwen":
      return "!bt";
    default:
      return "gt";
  }
}, Vt = (e) => {
  const o = Yt(e == null ? void 0 : e.Op), t = (e == null ? void 0 : e.Extent) ?? null;
  return {
    Op: o,
    Value: (e == null ? void 0 : e.Value) ?? null,
    Extent: Gt.includes(o) ? t : null
  };
}, Mo = (e) => Array.isArray(e) ? e.filter((o) => o == null ? void 0 : o.versionId).map((o) => ({
  versionId: o.versionId,
  ...o.alias ? { alias: o.alias } : {}
})) : [], Qo = (e = {}) => {
  const { id: o, ...t } = e || {};
  return {
    ...t,
    year: (e == null ? void 0 : e.year) ?? null,
    coefficient: (e == null ? void 0 : e.coefficient) ?? null
  };
}, xo = (e = {}) => {
  const { id: o, ...t } = e || {};
  return {
    ...t,
    visitLength: Vt(e == null ? void 0 : e.visitLength),
    dateRangeStart: (e == null ? void 0 : e.dateRangeStart) ?? null,
    dateRangeEnd: (e == null ? void 0 : e.dateRangeEnd) ?? null,
    ...Array.isArray(e == null ? void 0 : e.cpiCoefficients) ? {
      cpiCoefficients: e.cpiCoefficients.map(
        Qo
      )
    } : {}
  };
}, yt = (e) => ({
  ...e,
  targetCohorts: Mo(e == null ? void 0 : e.targetCohorts),
  visitLength: Vt(e == null ? void 0 : e.visitLength),
  dateRangeStart: (e == null ? void 0 : e.dateRangeStart) ?? null,
  dateRangeEnd: (e == null ? void 0 : e.dateRangeEnd) ?? null,
  ...Array.isArray(e == null ? void 0 : e.analyses) ? { analyses: e.analyses.map(xo) } : {}
}), $o = (e = {}) => {
  if (!(e != null && e.applyCpi))
    return {
      hasCpiNoCoefficients: !1,
      hasCpiIncompleteRow: !1,
      hasCpiNonPositiveCoefficient: !1,
      hasCpiDuplicateYears: !1,
      hasCpiBaseYearError: !1
    };
  const o = Array.isArray(e == null ? void 0 : e.cpiCoefficients) ? e.cpiCoefficients : [], t = (c) => ((c == null ? void 0 : c.year) ?? null) === null && ((c == null ? void 0 : c.coefficient) ?? null) === null, s = (c) => ((c == null ? void 0 : c.year) ?? null) !== null && ((c == null ? void 0 : c.coefficient) ?? null) !== null, r = o.filter((c) => !t(c)), n = o.filter(s), a = n.length === 0, l = r.some(
    (c) => !s(c)
  ), A = n.some(
    (c) => Number(c.coefficient) <= 0
  ), _ = n.map((c) => Number(c.year)), i = new Set(_).size !== _.length, T = (e == null ? void 0 : e.cpiBaseYear) ?? null, p = T !== null && !_.includes(Number(T));
  return {
    hasCpiNoCoefficients: a,
    hasCpiIncompleteRow: l,
    hasCpiNonPositiveCoefficient: A,
    hasCpiDuplicateYears: i,
    hasCpiBaseYearError: p
  };
}, Ct = (e = {}) => {
  var i, T, p;
  const o = Yt((i = e == null ? void 0 : e.visitLength) == null ? void 0 : i.Op), t = ((T = e == null ? void 0 : e.visitLength) == null ? void 0 : T.Value) ?? null, s = ((p = e == null ? void 0 : e.visitLength) == null ? void 0 : p.Extent) ?? null, r = Gt.includes(o) && t !== null && s !== null && Number(t) >= Number(s), n = (e == null ? void 0 : e.dateRangeStart) ?? null, a = (e == null ? void 0 : e.dateRangeEnd) ?? null, l = !!n != !!a, A = !!(n && a && n > a), _ = !Array.isArray(e == null ? void 0 : e.costMeasures) || e.costMeasures.length === 0;
  return {
    hasVisitLengthRangeError: r,
    hasDateRangePairError: l,
    hasDateRangeOrderError: A,
    hasCostMeasuresError: _,
    ...$o(e)
  };
}, Bo = {
  hasVisitLengthRangeError: !1,
  hasDateRangePairError: !1,
  hasDateRangeOrderError: !1,
  hasCostMeasuresError: !1,
  hasCpiNoCoefficients: !1,
  hasCpiIncompleteRow: !1,
  hasCpiNonPositiveCoefficient: !1,
  hasCpiDuplicateYears: !1,
  hasCpiBaseYearError: !1
}, Mt = (e = {}) => {
  const o = Array.isArray(e == null ? void 0 : e.analyses) ? e.analyses : null;
  return o && o.length ? o.reduce(
    (t, s) => {
      const r = Ct(s);
      return Object.keys(r).forEach((n) => {
        t[n] = t[n] || r[n];
      }), t;
    },
    { ...Bo }
  ) : Ct(e);
}, Ho = (e = {}) => {
  const o = Mt(e);
  return !!(o.hasVisitLengthRangeError || o.hasDateRangePairError || o.hasDateRangeOrderError || o.hasCpiNoCoefficients || o.hasCpiIncompleteRow || o.hasCpiNonPositiveCoefficient || o.hasCpiDuplicateYears || o.hasCpiBaseYearError);
}, jo = "pre-index", Wo = "post-index", zo = 365, qo = 1, dt = (e, o) => {
  const t = Number(e);
  return Number.isFinite(t) ? -Math.max(1, Math.abs(t)) : -o;
}, Xo = (e = {}) => {
  const {
    includePreIndexEvents: o,
    preIndexEventLookbackStart: t,
    preIndexEventLookbackEnd: s,
    ...r
  } = e, n = r.analysisType || (o === !0 ? jo : Wo);
  return {
    ...r,
    analysisType: n,
    collapseWindow: r.collapseWindow ?? r.combinationWindow,
    lookbackStartDay: dt(
      r.lookbackStartDay ?? t,
      zo
    ),
    lookbackEndDay: dt(
      r.lookbackEndDay ?? s,
      qo
    )
  };
}, sr = (e, o, t, s, r) => {
  const { entity: n, draft: a, status: l, updateEntity: A, ..._ } = Fo(e, o, t), {
    component: i,
    getTemplate: T,
    isUpload: p,
    atlasEntity: c,
    parseDesign: y,
    formatDesign: C,
    conceptSetAttr: O
  } = Oe(
    () => n != null && n.type && s && s[n.type] ? s[n.type] : {},
    [n == null ? void 0 : n.type, s]
  ), [D, I] = W(
    Vo,
    Yo
  ), m = R(async () => {
    try {
      const h = await r(o);
      I({
        type: j.GET_SUMMARY,
        payload: h
      });
    } catch {
    }
  }, [o]), f = (h, S, d) => {
    var N, E, L, U, P, Y, F, ce, le, G, se;
    switch (h) {
      case g.CUSTOM:
        return ((N = d == null ? void 0 : d.files) == null ? void 0 : N.length) > 0 && (d == null ? void 0 : d.executableFileName);
      case g.ESTIMATION:
        const ue = {
          doPositiveControlSynthesis: d.doPositiveControlSynthesis,
          cohortDefinitions: d.cohortDefinitions,
          conceptSetCrossReference: d.conceptSetCrossReference,
          conceptSets: d.conceptSets,
          negativeControlExposureCohortDefinition: d.negativeControlExposureCohortDefinition,
          negativeControls: d.negativeControls,
          positiveControlSynthesisArgs: d.positiveControlSynthesisArgs,
          negativeControlOutcomeCohortDefinition: d.negativeControlOutcomeCohortDefinition,
          targetComparatorOutcomes: (U = (L = (E = d.estimationAnalysisSettings) == null ? void 0 : E.analysisSpecification) == null ? void 0 : L.targetComparatorOutcomes) == null ? void 0 : U.map(
            (J) => ({
              comparatorId: J.comparatorId,
              outcomeIds: J.outcomeIds,
              targetId: J.targetId
            })
          ),
          cohortMethodAnalysisList: (Y = (P = d.estimationAnalysisSettings) == null ? void 0 : P.analysisSpecification) == null ? void 0 : Y.cohortMethodAnalysisList
        }, q = {
          doPositiveControlSynthesis: S.doPositiveControlSynthesis,
          cohortDefinitions: S.cohortDefinitions,
          conceptSetCrossReference: S.conceptSetCrossReference,
          conceptSets: S.conceptSets,
          negativeControlExposureCohortDefinition: S.negativeControlExposureCohortDefinition,
          negativeControls: S.negativeControls,
          positiveControlSynthesisArgs: S.positiveControlSynthesisArgs,
          negativeControlOutcomeCohortDefinition: S.negativeControlOutcomeCohortDefinition,
          targetComparatorOutcomes: (le = (ce = (F = S.estimationAnalysisSettings) == null ? void 0 : F.analysisSpecification) == null ? void 0 : ce.targetComparatorOutcomes) == null ? void 0 : le.map(
            (J) => ({
              comparatorId: J.comparatorId,
              outcomeIds: J.outcomeIds,
              targetId: J.targetId
            })
          ),
          cohortMethodAnalysisList: (se = (G = S.estimationAnalysisSettings) == null ? void 0 : G.analysisSpecification) == null ? void 0 : se.cohortMethodAnalysisList
        };
        return Te(ue, q);
      default:
        return Te({ ...T == null ? void 0 : T(), ...S }, d);
    }
  }, Q = (h, S, d) => {
    var N, E, L, U, P, Y, F, ce, le, G, se, ue;
    switch (h) {
      case g.CUSTOM:
        return Te(
          d == null ? void 0 : d.executableFileName,
          S == null ? void 0 : S.executableFileName
        ) && Te(d == null ? void 0 : d.cohorts, S == null ? void 0 : S.cohorts) && Te(d == null ? void 0 : d.conceptSets, S == null ? void 0 : S.conceptSets);
      case g.ESTIMATION: {
        const q = {
          doPositiveControlSynthesis: d.doPositiveControlSynthesis,
          cohortDefinitions: d.cohortDefinitions,
          conceptSetCrossReference: d.conceptSetCrossReference,
          conceptSets: d.conceptSets,
          negativeControlExposureCohortDefinition: d.negativeControlExposureCohortDefinition,
          negativeControls: d.negativeControls,
          positiveControlSynthesisArgs: d.positiveControlSynthesisArgs,
          negativeControlOutcomeCohortDefinition: d.negativeControlOutcomeCohortDefinition,
          targetComparatorOutcomes: (L = (E = (N = d.estimationAnalysisSettings) == null ? void 0 : N.analysisSpecification) == null ? void 0 : E.targetComparatorOutcomes) == null ? void 0 : L.map(
            (ie) => ({
              comparatorId: ie.comparatorId,
              outcomeIds: ie.outcomeIds,
              targetId: ie.targetId
            })
          ),
          cohortMethodAnalysisList: (P = (U = d.estimationAnalysisSettings) == null ? void 0 : U.analysisSpecification) == null ? void 0 : P.cohortMethodAnalysisList
        }, re = {
          doPositiveControlSynthesis: S.doPositiveControlSynthesis,
          cohortDefinitions: S.cohortDefinitions,
          conceptSetCrossReference: S.conceptSetCrossReference,
          conceptSets: S.conceptSets,
          negativeControlExposureCohortDefinition: S.negativeControlExposureCohortDefinition,
          negativeControls: S.negativeControls,
          positiveControlSynthesisArgs: S.positiveControlSynthesisArgs,
          negativeControlOutcomeCohortDefinition: S.negativeControlOutcomeCohortDefinition,
          targetComparatorOutcomes: (ce = (F = (Y = S.estimationAnalysisSettings) == null ? void 0 : Y.analysisSpecification) == null ? void 0 : F.targetComparatorOutcomes) == null ? void 0 : ce.map(
            (ie) => ({
              comparatorId: ie.comparatorId,
              outcomeIds: ie.outcomeIds,
              targetId: ie.targetId
            })
          ),
          cohortMethodAnalysisList: (G = (le = S.estimationAnalysisSettings) == null ? void 0 : le.analysisSpecification) == null ? void 0 : G.cohortMethodAnalysisList
        };
        return Te(q, re);
      }
      case g.COST: {
        const q = yt({
          ...T == null ? void 0 : T(),
          ...S
        }), re = yt(d);
        return Te(q, re);
      }
      default: {
        const q = JSON.parse(
          JSON.stringify({ ...T == null ? void 0 : T(), ...S })
        ), re = JSON.parse(JSON.stringify(d)), J = (() => {
          switch (h) {
            case g.COHORT_CHARACTERIZATION:
              return "strataConceptSets";
            case g.INCIDENCE:
              return "conceptSets";
          }
        })(), ie = {
          ...q,
          [J]: (se = q == null ? void 0 : q[J]) == null ? void 0 : se.map((H) => {
            var de;
            if (typeof H == "object" && H !== null) {
              const { uuid: Ge, type: Ye, ...be } = H;
              return Rt(be, (de = H.expression) == null ? void 0 : de.items);
            }
          }),
          ...q.ageBreaks ? q.ageBreaks.map((H) => (delete H.id, H)) : {}
        }, Fe = {
          ...re,
          [J]: (ue = re == null ? void 0 : re[J]) == null ? void 0 : ue.map((H) => {
            var de;
            if (typeof H == "object" && H !== null) {
              const { uuid: Ge, type: Ye, ...be } = H;
              return Rt(be, (de = H.expression) == null ? void 0 : de.items);
            }
          }),
          ...re.ageBreaks ? re.ageBreaks.map((H) => (delete H.id, H)) : {}
        };
        return Te(ie, Fe);
      }
    }
  }, $ = (h, S, d) => {
    var L, U, P, Y, F, ce, le, G, se, ue, q, re, J, ie, Fe, He, H, de, Ge, Ye, be, tt, ot, st;
    let N = !0, E = [];
    switch (h) {
      case g.COHORT:
      case g.SIMPLE_COUNTS_CHARACTERIZATION:
        S.cohortVersionId || (N = !1, E.push("add target cohort"));
        break;
      case g.COHORT_PATHWAY:
        (!S.targetCohorts || ((L = S.targetCohorts) == null ? void 0 : L.length) < 1) && (N = !1, E.push("add target cohorts")), ((U = S.eventCohorts) == null ? void 0 : U.length) < 1 && (N = !1, E.push("add event cohorts"));
        break;
      case g.INCIDENCE:
        (!S.targetCohorts || ((P = S.targetCohorts) == null ? void 0 : P.length) < 1) && (N = !1, E.push("add target cohorts")), (!S.outcomeCohorts || ((Y = S.outcomeCohorts) == null ? void 0 : Y.length) < 1) && (N = !1, E.push("add outcome cohorts"));
        break;
      case g.CUSTOM: {
        ((F = S == null ? void 0 : S.files) == null ? void 0 : F.length) < 1 && (N = !1, E.push("upload files")), S != null && S.executableFileName || (N = !1, E.push("entry point not selected")), (ce = S == null ? void 0 : S.cohorts) != null && ce.length && !((le = S == null ? void 0 : S.cohorts) != null && le.every((ge) => !!ge.alias)) && (N = !1, E.push("add alias name for each target cohort")), (G = S == null ? void 0 : S.conceptSets) != null && G.length && !((se = S == null ? void 0 : S.conceptSets) != null && se.every((ge) => !!ge.alias)) && (N = !1, E.push("add alias name for each concept set"));
        break;
      }
      case g.ESTIMATION:
        ((re = (q = (ue = S.estimationAnalysisSettings) == null ? void 0 : ue.analysisSpecification) == null ? void 0 : q.targetComparatorOutcomes) == null ? void 0 : re.length) < 1 && (N = !1), ((Fe = (ie = (J = S.estimationAnalysisSettings) == null ? void 0 : J.analysisSpecification) == null ? void 0 : ie.cohortMethodAnalysisList) == null ? void 0 : Fe.length) < 1 && (N = !1);
        break;
      case g.COHORT_CHARACTERIZATION:
        (!S.featureAnalyses || ((He = S.featureAnalyses) == null ? void 0 : He.length) < 1) && (N = !1, E.push("add feature analyses"));
      case g.BULK_COHORT_COUNTS:
        (!S.cohorts || ((H = S.cohorts) == null ? void 0 : H.length) < 1) && (N = !1, E.push("add target cohorts"));
        break;
      case g.DATACUT:
        (!S.cohorts || ((de = S.cohorts) == null ? void 0 : de.length) < 1) && (N = !1, E.push("add target cohorts")), ((Ge = Object.keys(S.includedTables)) == null ? void 0 : Ge.length) < 1 && (N = !1, E.push("select OMOP CDM tables")), S.cohortOption || (N = !1, E.push("select data to export"));
        break;
      case g.FEASIBILITY:
        (!S.targetCohorts || ((Ye = S.targetCohorts) == null ? void 0 : Ye.length) < 1) && (N = !1, E.push("add target cohorts"));
        break;
      case g.TIME_TO_EVENT: {
        if ((!S.targetCohorts || ((be = S.targetCohorts) == null ? void 0 : be.length) < 1) && (N = !1, E.push("add target cohorts")), ((tt = S.eventCohorts) == null ? void 0 : tt.length) < 1 && (N = !1, E.push("add outcome cohorts")), (ot = S.strata) == null ? void 0 : ot.some(
          (ye) => ye === "age_group" || (ye == null ? void 0 : ye.value) === "age_group"
        )) {
          const ye = S.ageBreaks || [];
          ye.length > 0 && ye.every(
            (ve) => ve != null && ve.Value != null && !Number.isNaN(Number(ve.Value))
          ) || (N = !1, E.push(
            "add at least one age break for age group stratification"
          ));
        }
        break;
      }
      case g.COST: {
        (!S.targetCohorts || ((st = S.targetCohorts) == null ? void 0 : st.length) < 1) && (N = !1, E.push("add target cohorts"));
        const {
          hasVisitLengthRangeError: ge,
          hasDateRangePairError: ye,
          hasDateRangeOrderError: rt,
          hasCostMeasuresError: ve,
          hasCpiNoCoefficients: xt,
          hasCpiIncompleteRow: $t,
          hasCpiNonPositiveCoefficient: Bt,
          hasCpiDuplicateYears: Ht,
          hasCpiBaseYearError: jt
        } = Mt(d);
        ve && (N = !1, E.push("select at least one cost measure in each analysis")), ge && (N = !1, E.push("set visit length start value less than end value")), ye && (N = !1, E.push("fill both event dates or leave both empty")), rt && (N = !1, E.push("set event start date not later than end date")), xt && (N = !1, E.push("add CPI coefficients or turn CPI off")), $t && (N = !1, E.push("fill both year and coefficient in every CPI row")), Bt && (N = !1, E.push("CPI coefficients must be greater than zero")), Ht && (N = !1, E.push("remove duplicate CPI years")), jt && (N = !1, E.push("CPI base year must be one of the listed years"));
        break;
      }
    }
    return { canExecute: N, messages: E };
  }, x = Oe(() => {
    var L, U, P, Y, F;
    const h = l === u.SUCCESS && D.designStatus === u.SUCCESS ? $(
      a == null ? void 0 : a.type,
      (a == null ? void 0 : a.design) || {},
      ((L = D.design) == null ? void 0 : L.design) || {}
    ) : { canExecute: !1, messages: [] }, S = (a == null ? void 0 : a.type) === g.COST ? Ho(((U = D.design) == null ? void 0 : U.design) || {}) : !1, d = l === u.SUCCESS && D.designStatus === u.SUCCESS ? Q(
      a == null ? void 0 : a.type,
      (a == null ? void 0 : a.design) || {},
      ((P = D.design) == null ? void 0 : P.design) || {}
    ) && Te(a == null ? void 0 : a.title, (Y = D.design) == null ? void 0 : Y.title) && Te(a == null ? void 0 : a.description, (F = D.design) == null ? void 0 : F.description) || S : !0, N = h.canExecute, E = h.messages;
    return {
      disableSave: d,
      canExecute: N,
      executionMessages: E
    };
  }, [a, D.design, T, l, D.designStatus]), B = Oe(() => {
    var N, E, L, U, P, Y, F;
    const h = f(
      a == null ? void 0 : a.type,
      (a == null ? void 0 : a.design) || {},
      ((N = D.design) == null ? void 0 : N.design) || {}
    ), S = (L = (E = D.design) == null ? void 0 : E.studyWindow) != null && L.startDate ? !nt(
      D.design.studyWindow.startDate,
      Et.ISO_DATE
    ) : !1, d = (P = (U = D.design) == null ? void 0 : U.studyWindow) != null && P.endDate ? !nt(
      D.design.studyWindow.endDate,
      Et.ISO_DATE
    ) : !1;
    return h && Te(a == null ? void 0 : a.title, (Y = D.design) == null ? void 0 : Y.title) && Te(a == null ? void 0 : a.description, (F = D.design) == null ? void 0 : F.description) || S || d;
  }, [a, D.design, T]), v = (h = []) => h.filter(
    (S) => S.currentVersionId && S.versionId !== S.currentVersionId
  ), fe = Oe(() => {
    var N, E;
    const h = (N = D.design) == null ? void 0 : N.design, S = (E = D.design) == null ? void 0 : E.type;
    let d = [];
    switch (S) {
      case g.COHORT_CHARACTERIZATION:
        d = v(h.cohorts);
        break;
      case g.INCIDENCE:
        d = [
          ...v(h.targetCohorts),
          ...v(h.outcomeCohorts)
        ];
        break;
      case g.COHORT_PATHWAY:
        d = [
          ...v(h.targetCohorts),
          ...v(h.eventCohorts)
        ];
        break;
      case g.ESTIMATION:
        d = [...v(h.cohortDefinitions)];
        break;
      case g.BULK_COHORT_COUNTS:
      case g.CUSTOM:
        d = v(h.cohorts);
        break;
      case g.COHORT:
      case g.SIMPLE_COUNTS_CHARACTERIZATION:
        d = v(
          h.cohort ? [h.cohort] : []
        );
        break;
      case g.FEASIBILITY:
      case g.TIME_TO_EVENT:
        d = [
          ...v(h.targetCohorts),
          ...v(h.eventCohorts)
        ];
        break;
      case g.COST:
        d = v(h.targetCohorts);
        break;
    }
    return d;
  }, [a, D.design]), Re = R(
    (h) => {
      I({
        type: j.SET_DESIGN
      });
      const S = T == null ? void 0 : T();
      try {
        setTimeout(() => {
          I({
            type: j.SET_DESIGN_SUCCESS,
            payload: {
              ...h,
              design: {
                ...S,
                ...h.design
              }
            }
          });
        }, 500);
      } catch (d) {
        I({
          type: j.SET_DESIGN_ERROR,
          payload: d
        });
      }
    },
    [T]
  ), V = (h) => {
    I({
      type: j.RELOAD_DESIGN_SUCCESS,
      payload: h
    });
  }, z = R(
    (h, S) => {
      I({
        type: j.UPDATE_DESIGN,
        payload: {
          key: h,
          value: S
        }
      });
    },
    [D.design, n]
  ), M = R(
    (h) => {
      I({
        type: j.UPDATE_DESIGN_BASE,
        payload: h
      });
    },
    []
  ), Ce = R(
    async (h) => {
      const S = h.type === g.COST, d = S ? {} : ["targetCohorts", "eventCohorts", "outcomeCohorts", "cohorts"].reduce(
        (N, E) => (h.design[E] && (N[E] = h.design[E].map((L) => ({
          versionId: L.versionId,
          ...L.alias ? { alias: L.alias } : {}
        }))), N),
        {}
      );
      try {
        let N = S ? h.design : {
          ...h.design,
          ...d
        };
        h.type === g.COHORT_PATHWAY && (N = Xo(N));
        let E = {
          ...h,
          design: N
        };
        await A(E);
      } catch (N) {
        console.error(N);
      }
    },
    [n, D.design]
  );
  return b(() => {
    l === u.SUCCESS && (Re(a), m());
  }, [l, a]), {
    ...D,
    ..._,
    conceptSetAttr: O,
    getCountsSummary: m,
    component: i,
    parseDesign: y,
    formatDesign: C,
    atlasEntity: c,
    entity: n,
    status: l,
    draft: a,
    updateEntity: A,
    setDesign: Re,
    updateDesign: z,
    updateDesignBase: M,
    saveDesign: Ce,
    reloadDesign: V,
    isEqual: B,
    outdatedCohortReferences: fe,
    ..._,
    permissions: x
  };
}, Ko = (e, o = "id") => {
  let t = {};
  return e.forEach((s) => {
    t[s[o]] = s;
  }), t;
}, Zo = () => Z.get("/tenant/analysis-types"), Jo = () => Z.get("/analysis/types");
var Le = /* @__PURE__ */ ((e) => (e.DOWNLOAD_REQUEST = "DOWNLOAD_REQUEST", e.DOWNLOAD_REQUEST_DONE = "DOWNLOAD_REQUEST_DONE", e.DOWNLOAD_REQUEST_FAILED = "DOWNLOAD_REQUEST_FAILED", e.SKIP_DOWNLOAD = "SKIP_DOWNLOAD", e))(Le || {});
const es = {
  analyses: null,
  original: null,
  status: u.INITIAL,
  error: null
}, ts = (e, o) => Ie(e, (t) => {
  switch (o.type) {
    case Le.DOWNLOAD_REQUEST:
      t.analyses = null, t.status = u.IN_PROGRESS, t.error = null;
      break;
    case Le.DOWNLOAD_REQUEST_DONE:
      t.analyses = o.payload.analyses, t.original = o.payload.original, t.status = u.SUCCESS;
      break;
    case Le.SKIP_DOWNLOAD:
      t.status = u.SUCCESS;
      break;
    case Le.DOWNLOAD_REQUEST_FAILED:
      t.status = u.ERROR, t.error = o.payload;
      break;
  }
}), rr = (e) => {
  const [o, t] = W(
    ts,
    es
  ), s = async () => {
    t({
      type: Le.DOWNLOAD_REQUEST
    });
    try {
      const r = e.preloadAnalysisTypes || (e.tenantId ? await Zo() : await Jo()), n = r.map((a) => a.type || a).map((a) => {
        var l;
        return (l = e.analyses) == null ? void 0 : l.find((A) => A.type === a);
      }).filter((a) => a);
      t({
        type: Le.DOWNLOAD_REQUEST_DONE,
        payload: {
          analyses: Ko(n, "type"),
          original: r
        }
      });
    } catch (r) {
      t({
        type: Le.DOWNLOAD_REQUEST_FAILED,
        payload: r
      });
    }
  };
  return b(() => {
    s();
  }, []), {
    ...o
  };
};
var me = /* @__PURE__ */ ((e) => (e.SAVE_ANALYSIS = "SAVE_ANALYSIS", e.SAVE_ANALYSIS_DONE = "SAVE_ANALYSIS_DONE", e.SAVE_ANALYSIS_FAILED = "SAVE_ANALYSIS_FAILED", e))(me || {});
const os = {
  status: u.INITIAL,
  entity: null
}, ss = (e, o) => Ie(e, (t) => {
  switch (o.type) {
    case me.SAVE_ANALYSIS:
      t.status = u.IN_PROGRESS;
      break;
    case me.SAVE_ANALYSIS_DONE:
      t.status = u.SUCCESS, t.entity = o.payload;
      break;
    case me.SAVE_ANALYSIS_FAILED:
      t.status = u.ERROR;
      break;
  }
}), rs = (e, o) => ({
  ...o,
  type: e.type
}), as = (e, o, t, s) => {
  switch (t) {
    case ct.WORKSPACE:
      return Z.post(`/workspace/analyses/import/${o}`, e);
    case ct.STUDY:
      return Z.post(`/studies/${s}/analyses/import/${o}`, e);
  }
}, ar = () => {
  const [e, o] = W(ss, os), t = R(
    async (s, r, n, a) => {
      const l = s.design ? JSON.parse(s.design) : {};
      o({
        type: me.SAVE_ANALYSIS
      });
      try {
        const A = await as(
          (a == null ? void 0 : a.parseDesign(s, l)) || rs(s, l),
          a.url,
          r,
          n
        );
        o({
          type: me.SAVE_ANALYSIS_DONE,
          payload: A
        });
      } catch (A) {
        o({
          type: me.SAVE_ANALYSIS_FAILED,
          patload: A
        });
      }
    },
    []
  );
  return {
    ...e,
    createNewAnalysis: t
  };
}, ns = (e, o) => Z.get(`/conceptset/${e}/export/${o}`), Es = (e) => Z.post(
  `conceptset/${e.conceptSetId}/included/codes`,
  e
), cs = (e) => Z.get(`/analyses/${e}/export`), Ot = (e, o) => Z.get(`/cohortdefinition/${e}/export/${o}`), ls = {
  exportConceptSet: null,
  exportConceptSetIds: null,
  exportConceptSetCodes: null,
  exportCohort: null,
  exportAnalysis: null,
  statusExportAnalysis: u.INITIAL,
  statusExportConceptSet: u.INITIAL,
  statusExportConceptSetIds: u.INITIAL,
  error: null
}, is = (e, o) => Ie(e, (t) => {
  switch (o.type) {
    case "GET_CONCEPT_SET_EXPORT_REQUEST":
      t.statusExportConceptSet = u.IN_PROGRESS;
      break;
    case "GET_CONCEPT_SET_EXPORT_DONE":
      t.statusExportConceptSet = u.SUCCESS, t.exportConceptSet = o.payload;
      break;
    case "GET_CONCEPT_SET_EXPORT_FAILED":
      t.statusExportConceptSet = u.ERROR, t.error = o.payload;
      break;
    case "GET_EXPORT_IDS_REQUEST":
      t.statusExportConceptSetIds = u.IN_PROGRESS;
      break;
    case "GET_EXPORT_IDS_DONE":
      t.statusExportConceptSetIds = u.SUCCESS, t.exportConceptSetIds = o.payload.map((s) => s == null ? void 0 : s.conceptId), t.exportConceptSetCodes = o.payload.map((s) => s == null ? void 0 : s.code);
      break;
    case "GET_EXPORT_IDS_FAILED":
      t.statusExportConceptSetIds = u.ERROR, t.error = o.payload;
      break;
    case "GET_EXPORT_ANALYSIS_REQUEST":
      t.statusExportAnalysis = u.IN_PROGRESS;
      break;
    case "GET_EXPORT_ANALYSIS_DONE":
      t.statusExportAnalysis = u.SUCCESS, t.exportAnalysis = o.payload;
      break;
    case "GET_EXPORT_ANALYSIS_FAILED":
      t.statusExportAnalysis = u.ERROR, t.error = o.payload;
      break;
    case "SAVE_EXPORT_COHORT":
      t.exportCohort = o.payload;
  }
}), nr = (e, o, t) => {
  const [s, r] = W(is, ls), n = R((i) => {
    try {
      l(i), a();
    } catch (T) {
      console.error(T);
    }
  }, []), a = R(async () => {
    r({
      type: "GET_EXPORT_IDS_REQUEST"
      /* GET_EXPORT_IDS_REQUEST */
    });
    try {
      const i = await Es({
        conceptSetId: o
      });
      r({
        type: "GET_EXPORT_IDS_DONE",
        payload: i
      });
    } catch (i) {
      r({
        type: "GET_EXPORT_IDS_FAILED",
        payload: i
      });
    }
  }, []), l = R(async (i) => {
    r({
      type: "GET_CONCEPT_SET_EXPORT_REQUEST"
      /* GET_CONCEPT_SET_EXPORT_REQUEST */
    });
    try {
      const T = await ns(o, i);
      r({
        type: "GET_CONCEPT_SET_EXPORT_DONE",
        payload: T
      });
    } catch (T) {
      console.error(T), r({
        type: "GET_CONCEPT_SET_EXPORT_FAILED",
        payload: T
      });
    }
  }, []), A = async (i, T = "circe") => {
    var p;
    if (i)
      try {
        let c = i;
        if (T !== "prometheus")
          try {
            c = await Ot(i.id, T);
          } catch (y) {
            const C = (p = y == null ? void 0 : y.response) == null ? void 0 : p.status;
            if (!([400, 404].includes(C) && (T === "atlas" || T === "circe")))
              throw y;
            const D = T === "atlas" ? "circe" : "atlas";
            c = await Ot(i.id, D);
          }
        r({
          type: "SAVE_EXPORT_COHORT",
          payload: c
        });
      } catch (c) {
        console.error(c), r({
          type: "SAVE_EXPORT_COHORT",
          payload: i
        });
      }
  }, _ = R(async () => {
    r({
      type: "GET_EXPORT_ANALYSIS_REQUEST"
      /* GET_EXPORT_ANALYSIS_REQUEST */
    });
    try {
      const i = await cs(o);
      r({
        type: "GET_EXPORT_ANALYSIS_DONE",
        payload: i
      });
    } catch (i) {
      r({
        type: "GET_EXPORT_ANALYSIS_FAILED",
        payload: i
      });
    }
  }, []);
  return b(() => {
    switch (e) {
      case to.ANALYSIS:
        _();
        break;
    }
  }, [t]), {
    ...s,
    getExportConceptSet: n,
    getExportCohort: A
  };
};
var Qe = /* @__PURE__ */ ((e) => (e.LOADING_FILE = "LOADING_FILE", e.LOADED_FILE_DONE = "LOADED_FILE_DONE", e.LOADED_FILE_FAILED = "LOADED_FILE_FAILED", e))(Qe || {}), K = /* @__PURE__ */ ((e) => (e.SAVE_FILE_REQUEST = "SAVE_FILE_REQUEST", e.SAVE_FILES_REQUEST_DONE = "SAVE_FILES_REQUEST_DONE", e.SAVE_FILES_REQUEST_FAILED = "SAVE_FILES_REQUEST_FAILED", e.SELECT_FILE = "SELECT_FILE", e.LOAD_FILE_REQUEST = "LOAD_FILE_REQUEST", e.LOAD_FILE_REQUEST_DONE = "LOAD_FILE_REQUEST_DONE", e.LOAD_FILE_REQUEST_FAILED = "LOAD_FILE_REQUEST_FAILED", e))(K || {}), Ze = /* @__PURE__ */ ((e) => (e.FOLDER = "FOLDER", e.FILE = "FILE", e.ZIP = "ZIP", e.COMPONENT = "COMPONENT", e))(Ze || {});
const Ts = (e) => {
  var s;
  var o = /(?:\.([^.]+))?$/;
  const t = (s = o.exec(e)[1]) == null ? void 0 : s.toUpperCase();
  return t ? lt[t] || lt.UNKNOWN : "FOLDER";
}, Nt = (e) => {
  const o = Object.defineProperties(
    {},
    { __size__: { value: 0, writable: !0 } }
  ), t = (s, r, n) => {
    if (s != null && s.length) {
      const a = s[0];
      r[a] || ((s == null ? void 0 : s.length) === 1 ? (r[a] = {
        ...n
      }, Object.defineProperties(r[a], {
        ext: { value: Ts(a) },
        __type__: { value: Ze.FILE },
        __name__: { value: a }
      })) : (r[a] = {}, Object.defineProperties(r[a], {
        ext: { value: "folder" },
        __type__: { value: Ze.FOLDER },
        __name__: { value: a },
        __size__: { value: 0, writable: !0 }
      })), r.__size__++), t(s.slice(1), r[a], n);
    }
  };
  return e.forEach((s) => {
    const r = s.fileMetadata.realName.split("/");
    t(r, o, s);
  }), o;
}, _s = (e, o) => Z.get(`/${o}/${e}/results/list?size=1000`), us = (e, o, t) => Z.get(`/${t}/${e}/results/${o}/download`), Ss = {
  files: null,
  hashMap: null,
  filesContent: null,
  status: u.INITIAL,
  selectedFile: void 0,
  error: null,
  fileTree: {}
}, ps = (e, o) => Ie(e, (t) => {
  switch (o.type) {
    case K.SAVE_FILE_REQUEST:
      t.status = u.IN_PROGRESS;
      break;
    case K.SAVE_FILES_REQUEST_DONE:
      t.status = u.SUCCESS, t.fileTree = o.payload.fileTree;
      break;
    case K.SAVE_FILES_REQUEST_FAILED:
      t.status = u.ERROR, t.files = o.payload;
      break;
    case K.SELECT_FILE:
      t.selectedFile === o.payload ? t.selectedFile = null : t.selectedFile = o.payload;
      break;
    case K.LOAD_FILE_REQUEST:
      t.status = Qe.LOADING_FILE;
      break;
    case K.LOAD_FILE_REQUEST_DONE:
      t.status = Qe.LOADED_FILE_DONE, t.filesContent || (t.filesContent = {}), o.payload.content && (t.filesContent[o.payload.id] = o.payload.content);
      break;
    case K.LOAD_FILE_REQUEST_FAILED:
      t.status = Qe.LOADED_FILE_FAILED, t.error = o.payload;
      break;
  }
}), Er = (e, o, t) => {
  const [s, r] = W(ps, Ss), n = R(async () => {
    r({
      type: K.SAVE_FILE_REQUEST
    });
    try {
      const _ = await _s(e, o), i = Nt(_.content);
      r({
        type: K.SAVE_FILES_REQUEST_DONE,
        payload: { fileTree: i }
      });
    } catch (_) {
      console.error(_), r({
        type: K.SAVE_FILES_REQUEST_FAILED,
        payload: _
      });
    }
  }, []), a = (_) => {
    const i = Nt(_);
    r({
      type: K.SAVE_FILES_REQUEST_DONE,
      payload: { fileTree: i }
    });
  }, l = (_) => {
    r({
      type: K.SELECT_FILE,
      payload: _
    });
  }, A = R(
    async (_) => {
      var i;
      if (r({
        type: K.LOAD_FILE_REQUEST
      }), (i = s.filesContent) != null && i[_])
        r({
          type: K.LOAD_FILE_REQUEST_DONE,
          payload: {
            id: _,
            content: null
          }
        });
      else
        try {
          const T = await us(e, _, o);
          r({
            type: K.LOAD_FILE_REQUEST_DONE,
            payload: {
              id: _,
              content: T
            }
          });
        } catch (T) {
          r({
            type: K.LOAD_FILE_REQUEST_FAILED,
            payload: T
          });
        }
    },
    [s.filesContent]
  );
  return b(() => {
    var _, i;
    (_ = s.selectedFile) != null && _.id && A((i = s.selectedFile) == null ? void 0 : i.id);
  }, [s.selectedFile]), b(() => {
    t && t.length > 0 ? a(t) : n();
  }, [t]), { ...s, selectFile: l };
}, As = {
  storage: {},
  status: u.INITIAL
}, Is = (e, o) => Ie(e, (t) => {
  switch (o.type) {
    case "INIT":
      t.status = u.SUCCESS, t.storage = o.payload;
      break;
    case "SET":
      t.status = u.IN_PROGRESS, t.storage = o.payload;
  }
}), cr = (e, o) => {
  const [t, s] = W(Is, As), r = R(
    (A) => {
      localStorage.setItem(e, JSON.stringify(t.storage));
    },
    [t.storage]
  ), n = R(() => {
    try {
      const A = localStorage.getItem(e) || JSON.stringify(o);
      s({
        type: "INIT",
        payload: JSON.parse(A || "{}")
      });
    } catch (A) {
      console.error("Problem to access local storage", A);
    }
  }, [t.storage]), a = R(
    (A, _) => {
      try {
        s({
          type: "SET",
          payload: {
            ...t.storage,
            [A]: _
          }
        });
      } catch (i) {
        console.error(`Problem to write prop ${A} to local storage`, i);
      }
    },
    [t.storage]
  ), l = R(
    (A) => {
      try {
        s({
          type: "SET",
          payload: {
            ...t.storage,
            ...A
          }
        });
      } catch (_) {
        console.error("Problem to write props to local storage", _);
      }
    },
    [t.storage]
  );
  return b(() => {
    n();
  }, []), {
    ...t,
    setProp: a,
    saveToStorage: r,
    mergeProps: l
  };
}, Rs = (e, o = "/studies/export-") => {
  const { pageNumber: t, pageSize: s, sortBy: r, query: n } = e, a = gt(r), l = `${o}list?size=${s || ""}&page=${t || ""}&sort=${a}&${n || ""}`;
  return Z.get(l);
}, ys = 50, Cs = { id: "modified.timestamp", desc: !0 }, Lt = (e = [], o = []) => {
  const t = [...e], s = new Set(e.map((r) => r == null ? void 0 : r.id));
  return o.forEach((r) => {
    s.has(r == null ? void 0 : r.id) || (t.push(r), s.add(r == null ? void 0 : r.id));
  }), t;
}, ds = (e, o, t = "") => {
  const s = [e].filter(Boolean);
  return o && t.trim() && s.push(
    [o, t.trim()].map(encodeURIComponent).join("=")
  ), s.join("&");
};
function lr(e, o, t = {}) {
  const {
    pageSize: s = ys,
    sortBy: r = Cs,
    query: n,
    searchFilterName: a
  } = t, [l, A] = oe([]), [_, i] = oe(u.INITIAL), [T, p] = oe(0), [c, y] = oe(1), [C, O] = oe(""), D = Oe(
    () => ds(n, a, C),
    [n, C, a]
  ), I = R(
    async (Q = 0, $ = !1) => {
      i(u.IN_PROGRESS), !$ && A([]);
      try {
        const x = await Rs(
          {
            pageNumber: Q,
            pageSize: s,
            sortBy: r,
            query: D
          },
          e
        );
        A((B) => {
          const v = x.content || [];
          return Lt($ ? B : o || [], v);
        }), p(Q), y(x.totalPages || 1), i(u.SUCCESS);
      } catch (x) {
        console.error(x), i(u.ERROR);
      }
    },
    [e, o, s, D, r]
  ), m = (Q) => {
    A(Q), p(0), y(1);
  }, f = R(() => {
    _ === u.IN_PROGRESS || T + 1 >= c || I(T + 1, !0);
  }, [I, T, _, c]);
  return b(() => {
    o && (i(u.SUCCESS), m(o)), I(0);
  }, [I, o]), {
    list: l,
    status: _,
    setInitialList: m,
    loadMore: f,
    search: C,
    setSearch: O,
    hasMore: T + 1 < c
  };
}
const Os = () => Z.get("/domains");
function ir() {
  const [e, o] = oe({
    status: u.INITIAL,
    domains: [],
    error: null
  }), t = R(async () => {
    try {
      const s = await Os();
      o((r) => ({ ...r, status: u.SUCCESS, domains: s }));
    } catch (s) {
      o((r) => ({ ...r, status: u.ERROR, error: s }));
    }
  }, []);
  return b(() => {
    t();
  }, []), { ...e };
}
const Ns = () => Z.get("/ai/00000000-0000-0000-0000-000000000000/api/v3/filter-options");
function Tr() {
  const [e, o] = oe({
    status: u.INITIAL,
    options: null,
    error: null
  }), t = R(async () => {
    try {
      const s = await Ns(), r = {
        domains: s.domains.map((n) => ({ name: n, value: n })),
        vocabularies: s.vocabularies.map((n) => ({
          name: n,
          value: n
        })),
        standard_concepts: s.standard_concepts.map((n) => ({ name: oo.get(n).caption, value: n })),
        concept_classes: s.concept_classes.map((n) => ({
          name: n,
          value: n
        }))
      };
      o((n) => ({ ...n, status: u.SUCCESS, options: r }));
    } catch (s) {
      o((r) => ({ ...r, status: u.ERROR, error: s }));
    }
  }, []);
  return b(() => {
    t();
  }, []), { ...e };
}
const Ls = () => Z.get("/ai/00000000-0000-0000-0000-000000000000/api/v3/available-models");
function _r() {
  const [e, o] = oe({
    status: u.INITIAL,
    options: null,
    error: null
  }), t = R(async () => {
    try {
      const s = await Ls();
      o((r) => ({
        ...r,
        status: u.SUCCESS,
        options: s.availableModels.map((n) => ({
          name: n.modelName,
          value: n.modelId,
          isDefault: n.isDefault
        }))
      }));
    } catch (s) {
      o((r) => ({ ...r, status: u.ERROR, error: s }));
    }
  }, []);
  return b(() => {
    t();
  }, []), { ...e };
}
const Ds = (e) => e.map((o) => ({
  ...o,
  alias: Zt(o)
}));
function Dt(e, o = "id") {
  return e != null && e.length ? e.filter((t) => !!t).reduce(
    (t, s) => ({
      ...t,
      [s[o]]: { ...s, value: s.id }
    }),
    {}
  ) : {};
}
function ur(e, o, t, s, r = "id", n) {
  const [a, l] = oe(
    () => Dt(e, r)
  ), A = (p, c) => {
    const y = s ? Ds(Array.isArray(p) ? p : [p]) : Array.isArray(p) ? p : [p];
    l((C) => {
      const O = Dt(y, r), D = { ...o ? C : {}, ...O };
      return t(Object.values(D)), D;
    }), c();
  }, _ = async (p) => {
    const { id: c, versionId: y, currentVersionId: C } = p, O = await (n == null ? void 0 : n(c).catch(() => null));
    l((D) => {
      var m;
      const I = { ...D };
      return delete I[y], I[C] = {
        ...D[y],
        versionId: (O == null ? void 0 : O.versionId) || C,
        name: (O == null ? void 0 : O.name) || ((m = D[y]) == null ? void 0 : m.name)
      }, t(Object.values(I)), I;
    });
  }, i = (p) => {
    l((c) => {
      const y = { ...c };
      return delete y[p], t(Object.values(y)), y;
    });
  }, T = R((p) => {
    l((c) => {
      const y = { ...c };
      return y[p[r]] = p, t(Object.values(y)), y;
    });
  }, []);
  return { state: a, updateList: A, refreshVersion: _, removeItem: i, updateItem: T };
}
function Sr(e, o, t = !0) {
  const [s, r] = oe(null), [n, a] = oe(u.INITIAL), [l, A] = oe(null), _ = R(
    async (...i) => {
      a(u.IN_PROGRESS);
      try {
        const T = await e(...i);
        r(T), a(u.SUCCESS);
      } catch (T) {
        console.error(T), A(T), a(u.ERROR);
      }
    },
    [e]
  );
  return b(() => {
    r(null);
  }, [e]), b(() => {
    t && _(o, {});
  }, [o, _, t]), { state: s, status: n, error: l, getData: _ };
}
function pr() {
  const e = _e(null), [o, t] = oe({ width: 0, height: 0 });
  return b(() => {
    if (!e.current) return;
    const s = new ResizeObserver((r) => {
      for (let n of r) {
        const { width: a, height: l } = n.contentRect;
        t({ width: a, height: l });
      }
    });
    return s.observe(e.current), () => s.disconnect();
  }, []), [e, o];
}
const hs = (e, o, t) => Z.post(`/${o}/${e}/ai-generate`, t), Ar = (e, o, t, s) => ({ generate: R(
  async (n, a) => {
    try {
      const l = t || await e({
        name: n.title,
        studyId: o
      });
      if (!l) throw new Error("Cohort creation failed.");
      const A = hs(l.id, s, n);
      return a == null || a(l), await A, l;
    } catch (l) {
      throw console.error("Error in generate function:", l), l;
    }
  },
  [e, s, t, o]
) }), ms = (e, o) => Z.get("/events/ai", {
  params: e,
  signal: o
}), Us = /* @__PURE__ */ new Set([
  "COHORT_AI_GENERATION_COMPLETE",
  "CONCEPTSET_AI_GENERATION_COMPLETE"
]), bs = /* @__PURE__ */ new Set(["AI_GENERATION_FAILED"]), gs = /* @__PURE__ */ new Set([
  "DONE",
  "COMPLETE",
  "COMPLETED",
  "SUCCESS",
  "SUCCEEDED",
  "FINISHED"
]), Ps = /* @__PURE__ */ new Set(["ERROR", "FAILED", "FAILURE"]), De = (e) => typeof e == "string" ? e.trim().toUpperCase() : "", ze = (e) => !!(e && typeof e == "object" && typeof e.type == "string"), Qt = (e) => {
  if (Array.isArray(e))
    return e.filter(ze);
  if (!e || typeof e != "object")
    return [];
  const o = e, t = ["events", "content", "items", "data", "results"];
  for (const s of t) {
    const r = o[s];
    if (Array.isArray(r))
      return r.filter(ze);
  }
  return Object.values(o).filter(ze);
}, fs = (e) => {
  const o = e.subject ?? {};
  return [
    De(e.status),
    De(o.status),
    De(o.state),
    De(o.aiStatus),
    De(o.generationStatus),
    De(o.result)
  ].filter(Boolean);
}, vs = (e) => {
  const o = De(e.type);
  if (!o)
    return null;
  if (bs.has(o) || o.endsWith("_FAILED"))
    return "ERROR";
  if (Us.has(o) || o.endsWith("_COMPLETE"))
    return "DONE";
  const t = fs(e);
  return t.some((s) => Ps.has(s)) ? "ERROR" : o.includes("AI_GENERATION") && t.some((s) => gs.has(s)) ? "DONE" : null;
};
function ws(e) {
  return Qt(e);
}
function ks(e) {
  const o = Qt(e);
  if (o.length === 0)
    return null;
  for (const t of o) {
    const s = vs(t);
    if (s === "ERROR")
      return "ERROR";
    if (s === "DONE")
      return "DONE";
  }
  return null;
}
function Ir() {
  const [e, o] = oe(), [t, s] = oe(null), r = _e((/* @__PURE__ */ new Date()).toISOString()), n = Oe(() => (/* @__PURE__ */ new Date()).toISOString(), []), a = _e(!1), l = _e(null), A = R(
    async ({ subjectId: T, signal: p }) => await ms(
      {
        rand: (/* @__PURE__ */ new Date()).toISOString(),
        since: r.current,
        ...T ? { subjectId: T } : {}
      },
      p
    ),
    [r]
  ), _ = R(() => {
    var T;
    a.current = !1, (T = l.current) == null || T.abort(), l.current = null, o((p) => p === "DONE" ? "DONE" : "INITIAL");
  }, []), i = R(
    async (T) => {
      if (a.current) return;
      r.current = (T == null ? void 0 : T.since) || (/* @__PURE__ */ new Date()).toISOString(), s(null), o("IN_PROGRESS"), a.current = !0;
      const p = new AbortController();
      l.current = p;
      try {
        for (; a.current && !p.signal.aborted; ) {
          const c = await A({
            subjectId: T == null ? void 0 : T.subjectId,
            signal: p.signal
          }), y = ws(c);
          if (y.length > 0) {
            const O = ks(y);
            if (O == "DONE") {
              a.current = !1, o("DONE"), l.current = null;
              return;
            }
            if (O == "ERROR")
              throw new Error(O);
          }
          const C = y.map((O) => O == null ? void 0 : O.timestamp).filter((O) => typeof O == "string").map((O) => Date.parse(O)).filter((O) => !Number.isNaN(O)).sort().pop();
          C && (r.current = new Date(
            Math.max(0, C - 1)
          ).toISOString());
        }
        p.signal.aborted || o("IDLE");
      } catch (c) {
        if (p.signal.aborted) return;
        s(String((c == null ? void 0 : c.message) ?? c)), o("ERROR"), a.current = !1, l.current = null;
      }
    },
    [A]
  );
  return {
    status: e,
    error: t,
    start: i,
    stop: _,
    getCurrentTimestamp: () => r.current,
    resetTimestamp: (T = n) => {
      r.current = T;
    }
  };
}
export {
  io as DialogContext,
  $s as DialogProvider,
  Ft as FILTER_PANEL_INITIAL_STATE,
  Ze as FileExplorerTypes,
  ee as FilterPanelActions,
  As as INITIAL_STATE,
  Ao as ModalContext,
  js as ModalProvider,
  zs as StudyVocabulariesContext,
  K as UseFileExplorer,
  Qe as UseFileExplorerStatus,
  X as UseMetadataValues,
  Se as UseMetadataValuesStatus,
  Pe as getOverlayHistoryCount,
  vt as getOverlayHistoryState,
  Be as goBackOverlayHistory,
  wt as pushOverlayHistoryState,
  Is as reducer,
  kt as subscribeOverlayHistoryPop,
  Ir as useAiEventsApi,
  ar as useAnalysisImport,
  _r as useAvailableModels,
  sr as useDesign,
  ir as useDomains,
  rr as useDownloadAnalysisTypes,
  pr as useElementSize,
  xs as useEntityList,
  Fo as useEntityNew,
  nr as useExport,
  lr as useExportList,
  Er as useFileExplorer,
  Tr as useFilterOptions,
  Bs as useFilters,
  Ar as useGenerate,
  Zs as useInterval,
  Js as useIntervalWithCondition,
  Hs as useList,
  cr as useLocalStorage,
  er as useMetadata,
  or as useMetadataValues,
  Sr as useRequest,
  qs as useSections,
  Xs as useSectionsNew,
  Ks as useSelectedConcepts,
  ur as useSimpleImport,
  Ws as useStudyVocabs,
  tr as useVersions
};
//# sourceMappingURL=hooks.js.map
